export const tickets = [
    {
        "price": 81126,
        "carrier": "S7",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T13:05:00.000Z",
                "stops": [
                    "IST",
                    "SIN"
                ],
                "duration": 1154
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T02:08:00.000Z",
                "stops": [
                    "SIN",
                    "DXB",
                    "IST"
                ],
                "duration": 1339
            }
        ]
    },
    {
        "price": 70185,
        "carrier": "FV",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T10:02:00.000Z",
                "stops": [
                    "SHA",
                    "DXB"
                ],
                "duration": 1768
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T03:31:00.000Z",
                "stops": [
                    "IST"
                ],
                "duration": 1908
            }
        ]
    },
    {
        "price": 53591,
        "carrier": "FV",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-10T22:42:00.000Z",
                "stops": [
                    "HKG"
                ],
                "duration": 1240
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-30T22:39:00.000Z",
                "stops": [
                    "DXB",
                    "SIN"
                ],
                "duration": 1306
            }
        ]
    },
    {
        "price": 41599,
        "carrier": "S7",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T15:53:00.000Z",
                "stops": [
                    "SHA",
                    "HKG"
                ],
                "duration": 1030
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T00:08:00.000Z",
                "stops": [],
                "duration": 868
            }
        ]
    },
    {
        "price": 83950,
        "carrier": "SU",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T06:35:00.000Z",
                "stops": [
                    "KUL",
                    "SIN"
                ],
                "duration": 678
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T11:16:00.000Z",
                "stops": [],
                "duration": 1294
            }
        ]
    },
    {
        "price": 84158,
        "carrier": "TG",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T09:02:00.000Z",
                "stops": [],
                "duration": 897
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T16:58:00.000Z",
                "stops": [
                    "HKG"
                ],
                "duration": 1350
            }
        ]
    },
    {
        "price": 29190,
        "carrier": "MH",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T10:42:00.000Z",
                "stops": [
                    "SIN"
                ],
                "duration": 1070
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T04:55:00.000Z",
                "stops": [],
                "duration": 659
            }
        ]
    },
    {
        "price": 56961,
        "carrier": "S7",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T17:13:00.000Z",
                "stops": [
                    "SIN"
                ],
                "duration": 762
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T12:22:00.000Z",
                "stops": [
                    "BKK",
                    "SHA",
                    "HKG"
                ],
                "duration": 1356
            }
        ]
    },
    {
        "price": 80271,
        "carrier": "EK",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T11:47:00.000Z",
                "stops": [],
                "duration": 715
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-30T23:11:00.000Z",
                "stops": [],
                "duration": 1312
            }
        ]
    },
    {
        "price": 62654,
        "carrier": "TG",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T07:53:00.000Z",
                "stops": [
                    "KUL"
                ],
                "duration": 970
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T09:12:00.000Z",
                "stops": [
                    "SHA",
                    "SIN",
                    "DXB"
                ],
                "duration": 1998
            }
        ]
    },
    {
        "price": 23512,
        "carrier": "EY",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T12:48:00.000Z",
                "stops": [
                    "KUL"
                ],
                "duration": 732
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T04:28:00.000Z",
                "stops": [
                    "KUL"
                ],
                "duration": 738
            }
        ]
    },
    {
        "price": 47523,
        "carrier": "EY",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T01:09:00.000Z",
                "stops": [
                    "HKG",
                    "KUL"
                ],
                "duration": 922
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T16:34:00.000Z",
                "stops": [],
                "duration": 1366
            }
        ]
    },
    {
        "price": 64228,
        "carrier": "EY",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T15:36:00.000Z",
                "stops": [
                    "AUH"
                ],
                "duration": 1529
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T06:25:00.000Z",
                "stops": [
                    "SIN",
                    "SHA"
                ],
                "duration": 1519
            }
        ]
    },
    {
        "price": 39584,
        "carrier": "TG",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T05:30:00.000Z",
                "stops": [],
                "duration": 1650
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-30T23:12:00.000Z",
                "stops": [
                    "AUH",
                    "BKK",
                    "KUL"
                ],
                "duration": 1622
            }
        ]
    },
    {
        "price": 24323,
        "carrier": "EK",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T15:33:00.000Z",
                "stops": [],
                "duration": 1710
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T09:00:00.000Z",
                "stops": [],
                "duration": 960
            }
        ]
    },
    {
        "price": 77820,
        "carrier": "MH",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T17:37:00.000Z",
                "stops": [
                    "HKG"
                ],
                "duration": 1903
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T16:56:00.000Z",
                "stops": [
                    "HKG",
                    "IST",
                    "KUL"
                ],
                "duration": 1083
            }
        ]
    },
    {
        "price": 62188,
        "carrier": "FV",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T06:13:00.000Z",
                "stops": [
                    "BKK",
                    "DXB"
                ],
                "duration": 1954
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T02:07:00.000Z",
                "stops": [
                    "BKK"
                ],
                "duration": 1381
            }
        ]
    },
    {
        "price": 83088,
        "carrier": "S7",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T14:45:00.000Z",
                "stops": [],
                "duration": 781
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-30T22:28:00.000Z",
                "stops": [
                    "SIN",
                    "BKK",
                    "KUL"
                ],
                "duration": 1275
            }
        ]
    },
    {
        "price": 94072,
        "carrier": "SU",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T15:04:00.000Z",
                "stops": [],
                "duration": 686
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T03:54:00.000Z",
                "stops": [
                    "BKK",
                    "SIN"
                ],
                "duration": 1183
            }
        ]
    },
    {
        "price": 76721,
        "carrier": "MH",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T15:27:00.000Z",
                "stops": [
                    "AUH",
                    "IST",
                    "BKK"
                ],
                "duration": 1202
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T05:22:00.000Z",
                "stops": [],
                "duration": 1112
            }
        ]
    },
    {
        "price": 98795,
        "carrier": "EK",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T10:37:00.000Z",
                "stops": [
                    "BKK"
                ],
                "duration": 971
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T05:27:00.000Z",
                "stops": [
                    "SIN",
                    "KUL",
                    "SHA"
                ],
                "duration": 944
            }
        ]
    },
    {
        "price": 34785,
        "carrier": "S7",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T08:57:00.000Z",
                "stops": [],
                "duration": 888
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T08:14:00.000Z",
                "stops": [
                    "HKG",
                    "SIN",
                    "BKK"
                ],
                "duration": 1655
            }
        ]
    },
    {
        "price": 60099,
        "carrier": "EY",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T10:08:00.000Z",
                "stops": [
                    "BKK",
                    "SHA"
                ],
                "duration": 815
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T13:24:00.000Z",
                "stops": [
                    "KUL",
                    "AUH"
                ],
                "duration": 1373
            }
        ]
    },
    {
        "price": 18523,
        "carrier": "EK",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T00:30:00.000Z",
                "stops": [
                    "AUH",
                    "SIN",
                    "SHA"
                ],
                "duration": 1719
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-30T23:59:00.000Z",
                "stops": [
                    "KUL",
                    "SIN"
                ],
                "duration": 1440
            }
        ]
    },
    {
        "price": 62125,
        "carrier": "EY",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T14:34:00.000Z",
                "stops": [],
                "duration": 1078
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-30T22:36:00.000Z",
                "stops": [
                    "IST",
                    "BKK",
                    "SIN"
                ],
                "duration": 905
            }
        ]
    },
    {
        "price": 29445,
        "carrier": "SU",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T01:26:00.000Z",
                "stops": [],
                "duration": 933
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T04:16:00.000Z",
                "stops": [
                    "AUH",
                    "HKG"
                ],
                "duration": 946
            }
        ]
    },
    {
        "price": 74696,
        "carrier": "TG",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T16:47:00.000Z",
                "stops": [
                    "HKG",
                    "IST",
                    "KUL"
                ],
                "duration": 1977
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T06:38:00.000Z",
                "stops": [
                    "SHA",
                    "IST",
                    "KUL"
                ],
                "duration": 1841
            }
        ]
    },
    {
        "price": 61219,
        "carrier": "TG",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T00:17:00.000Z",
                "stops": [],
                "duration": 1585
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T04:58:00.000Z",
                "stops": [
                    "SIN",
                    "HKG",
                    "AUH"
                ],
                "duration": 953
            }
        ]
    },
    {
        "price": 90033,
        "carrier": "FV",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T13:10:00.000Z",
                "stops": [
                    "KUL",
                    "SHA",
                    "SIN"
                ],
                "duration": 1191
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T02:10:00.000Z",
                "stops": [],
                "duration": 649
            }
        ]
    },
    {
        "price": 26882,
        "carrier": "SU",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T12:56:00.000Z",
                "stops": [
                    "KUL"
                ],
                "duration": 799
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T08:34:00.000Z",
                "stops": [
                    "BKK"
                ],
                "duration": 1910
            }
        ]
    },
    {
        "price": 80571,
        "carrier": "SU",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T12:56:00.000Z",
                "stops": [
                    "DXB",
                    "KUL",
                    "SHA"
                ],
                "duration": 727
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-30T22:54:00.000Z",
                "stops": [
                    "SHA",
                    "DXB"
                ],
                "duration": 1976
            }
        ]
    },
    {
        "price": 68731,
        "carrier": "EK",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T10:37:00.000Z",
                "stops": [],
                "duration": 1907
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T07:24:00.000Z",
                "stops": [
                    "AUH"
                ],
                "duration": 1321
            }
        ]
    },
    {
        "price": 43678,
        "carrier": "S7",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T05:35:00.000Z",
                "stops": [
                    "IST"
                ],
                "duration": 1814
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T04:46:00.000Z",
                "stops": [
                    "AUH",
                    "HKG"
                ],
                "duration": 1339
            }
        ]
    },
    {
        "price": 57633,
        "carrier": "S7",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T15:48:00.000Z",
                "stops": [
                    "AUH",
                    "KUL"
                ],
                "duration": 1026
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T14:07:00.000Z",
                "stops": [
                    "BKK",
                    "SIN"
                ],
                "duration": 1349
            }
        ]
    },
    {
        "price": 16165,
        "carrier": "EY",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T01:58:00.000Z",
                "stops": [
                    "KUL",
                    "HKG",
                    "BKK"
                ],
                "duration": 1146
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T13:38:00.000Z",
                "stops": [
                    "IST",
                    "BKK",
                    "AUH"
                ],
                "duration": 1099
            }
        ]
    },
    {
        "price": 49075,
        "carrier": "TG",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T04:00:00.000Z",
                "stops": [
                    "DXB",
                    "SHA"
                ],
                "duration": 926
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T03:52:00.000Z",
                "stops": [
                    "AUH",
                    "SIN",
                    "IST"
                ],
                "duration": 1678
            }
        ]
    },
    {
        "price": 48378,
        "carrier": "SU",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-10T23:20:00.000Z",
                "stops": [
                    "BKK",
                    "AUH"
                ],
                "duration": 1639
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T15:00:00.000Z",
                "stops": [
                    "BKK"
                ],
                "duration": 1732
            }
        ]
    },
    {
        "price": 98645,
        "carrier": "EY",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T11:46:00.000Z",
                "stops": [
                    "KUL",
                    "IST",
                    "AUH"
                ],
                "duration": 1561
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T01:41:00.000Z",
                "stops": [],
                "duration": 1909
            }
        ]
    },
    {
        "price": 48431,
        "carrier": "MH",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T17:58:00.000Z",
                "stops": [
                    "IST",
                    "HKG"
                ],
                "duration": 1632
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T01:11:00.000Z",
                "stops": [],
                "duration": 1696
            }
        ]
    },
    {
        "price": 44773,
        "carrier": "EK",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T10:35:00.000Z",
                "stops": [
                    "SHA",
                    "HKG",
                    "BKK"
                ],
                "duration": 792
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T10:33:00.000Z",
                "stops": [
                    "KUL"
                ],
                "duration": 1449
            }
        ]
    },
    {
        "price": 40223,
        "carrier": "MH",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T08:14:00.000Z",
                "stops": [
                    "BKK",
                    "DXB"
                ],
                "duration": 852
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-30T22:40:00.000Z",
                "stops": [
                    "SIN",
                    "HKG",
                    "DXB"
                ],
                "duration": 1145
            }
        ]
    },
    {
        "price": 65907,
        "carrier": "TG",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T01:02:00.000Z",
                "stops": [
                    "KUL",
                    "DXB"
                ],
                "duration": 1749
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T16:32:00.000Z",
                "stops": [
                    "AUH",
                    "HKG"
                ],
                "duration": 1890
            }
        ]
    },
    {
        "price": 19185,
        "carrier": "S7",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T14:14:00.000Z",
                "stops": [
                    "SIN"
                ],
                "duration": 883
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T03:45:00.000Z",
                "stops": [],
                "duration": 1242
            }
        ]
    },
    {
        "price": 79288,
        "carrier": "S7",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T13:57:00.000Z",
                "stops": [
                    "DXB",
                    "AUH"
                ],
                "duration": 1007
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T06:04:00.000Z",
                "stops": [
                    "BKK"
                ],
                "duration": 807
            }
        ]
    },
    {
        "price": 72928,
        "carrier": "TG",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T13:46:00.000Z",
                "stops": [
                    "KUL"
                ],
                "duration": 706
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T08:23:00.000Z",
                "stops": [
                    "KUL",
                    "SIN"
                ],
                "duration": 1870
            }
        ]
    },
    {
        "price": 49698,
        "carrier": "TG",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T06:53:00.000Z",
                "stops": [
                    "AUH",
                    "BKK"
                ],
                "duration": 1761
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T11:14:00.000Z",
                "stops": [],
                "duration": 987
            }
        ]
    },
    {
        "price": 24286,
        "carrier": "SU",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T05:32:00.000Z",
                "stops": [],
                "duration": 1638
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-30T21:41:00.000Z",
                "stops": [],
                "duration": 779
            }
        ]
    },
    {
        "price": 46774,
        "carrier": "EK",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T00:27:00.000Z",
                "stops": [
                    "HKG"
                ],
                "duration": 915
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T12:54:00.000Z",
                "stops": [
                    "KUL"
                ],
                "duration": 1688
            }
        ]
    },
    {
        "price": 64779,
        "carrier": "EK",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T12:52:00.000Z",
                "stops": [],
                "duration": 1486
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T11:11:00.000Z",
                "stops": [],
                "duration": 1765
            }
        ]
    },
    {
        "price": 21315,
        "carrier": "EY",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-10T21:25:00.000Z",
                "stops": [],
                "duration": 762
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-30T21:33:00.000Z",
                "stops": [
                    "AUH",
                    "IST"
                ],
                "duration": 883
            }
        ]
    },
    {
        "price": 86179,
        "carrier": "TG",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T08:36:00.000Z",
                "stops": [
                    "KUL",
                    "SHA",
                    "HKG"
                ],
                "duration": 841
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T14:34:00.000Z",
                "stops": [],
                "duration": 1007
            }
        ]
    },
    {
        "price": 59212,
        "carrier": "S7",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T04:10:00.000Z",
                "stops": [
                    "SIN",
                    "IST"
                ],
                "duration": 1714
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-30T22:23:00.000Z",
                "stops": [
                    "BKK",
                    "SIN"
                ],
                "duration": 1150
            }
        ]
    },
    {
        "price": 26014,
        "carrier": "FV",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T04:46:00.000Z",
                "stops": [
                    "BKK",
                    "IST"
                ],
                "duration": 1840
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T04:21:00.000Z",
                "stops": [
                    "SIN"
                ],
                "duration": 1476
            }
        ]
    },
    {
        "price": 19549,
        "carrier": "S7",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T04:14:00.000Z",
                "stops": [
                    "HKG",
                    "SHA"
                ],
                "duration": 1885
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T01:45:00.000Z",
                "stops": [
                    "IST"
                ],
                "duration": 1831
            }
        ]
    },
    {
        "price": 82230,
        "carrier": "SU",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-10T22:16:00.000Z",
                "stops": [],
                "duration": 668
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T03:47:00.000Z",
                "stops": [
                    "SIN",
                    "SHA"
                ],
                "duration": 1344
            }
        ]
    },
    {
        "price": 16684,
        "carrier": "EK",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T11:04:00.000Z",
                "stops": [
                    "DXB",
                    "SIN",
                    "HKG"
                ],
                "duration": 1921
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T09:52:00.000Z",
                "stops": [],
                "duration": 1031
            }
        ]
    },
    {
        "price": 55374,
        "carrier": "EY",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T17:51:00.000Z",
                "stops": [
                    "HKG"
                ],
                "duration": 1380
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T14:35:00.000Z",
                "stops": [
                    "KUL",
                    "IST"
                ],
                "duration": 1476
            }
        ]
    },
    {
        "price": 49485,
        "carrier": "TG",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T02:58:00.000Z",
                "stops": [
                    "AUH",
                    "SIN"
                ],
                "duration": 1951
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T17:45:00.000Z",
                "stops": [
                    "SHA"
                ],
                "duration": 931
            }
        ]
    },
    {
        "price": 65812,
        "carrier": "EY",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T17:05:00.000Z",
                "stops": [
                    "SHA",
                    "IST",
                    "DXB"
                ],
                "duration": 782
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T14:40:00.000Z",
                "stops": [],
                "duration": 828
            }
        ]
    },
    {
        "price": 25095,
        "carrier": "EK",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T13:45:00.000Z",
                "stops": [
                    "AUH",
                    "BKK"
                ],
                "duration": 1834
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T00:18:00.000Z",
                "stops": [
                    "SIN"
                ],
                "duration": 1569
            }
        ]
    },
    {
        "price": 71177,
        "carrier": "MH",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T05:52:00.000Z",
                "stops": [],
                "duration": 1340
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T09:16:00.000Z",
                "stops": [
                    "KUL",
                    "DXB"
                ],
                "duration": 795
            }
        ]
    },
    {
        "price": 25211,
        "carrier": "EK",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T05:23:00.000Z",
                "stops": [],
                "duration": 1848
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-30T21:54:00.000Z",
                "stops": [],
                "duration": 791
            }
        ]
    },
    {
        "price": 43878,
        "carrier": "EK",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T17:44:00.000Z",
                "stops": [],
                "duration": 1941
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T10:58:00.000Z",
                "stops": [],
                "duration": 1440
            }
        ]
    },
    {
        "price": 65022,
        "carrier": "SU",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T00:54:00.000Z",
                "stops": [],
                "duration": 718
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T07:02:00.000Z",
                "stops": [
                    "DXB",
                    "SIN",
                    "BKK"
                ],
                "duration": 619
            }
        ]
    },
    {
        "price": 24123,
        "carrier": "MH",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T14:46:00.000Z",
                "stops": [],
                "duration": 1276
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-30T22:30:00.000Z",
                "stops": [
                    "KUL",
                    "AUH",
                    "HKG"
                ],
                "duration": 1312
            }
        ]
    },
    {
        "price": 97430,
        "carrier": "S7",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T10:07:00.000Z",
                "stops": [
                    "SIN"
                ],
                "duration": 1876
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-30T23:16:00.000Z",
                "stops": [],
                "duration": 1680
            }
        ]
    },
    {
        "price": 84086,
        "carrier": "TG",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-10T22:50:00.000Z",
                "stops": [
                    "IST"
                ],
                "duration": 1679
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T15:24:00.000Z",
                "stops": [
                    "DXB",
                    "SIN",
                    "AUH"
                ],
                "duration": 1117
            }
        ]
    },
    {
        "price": 33092,
        "carrier": "FV",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T08:34:00.000Z",
                "stops": [],
                "duration": 1075
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-30T22:14:00.000Z",
                "stops": [
                    "SHA"
                ],
                "duration": 976
            }
        ]
    },
    {
        "price": 15186,
        "carrier": "EY",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T11:30:00.000Z",
                "stops": [
                    "IST",
                    "BKK",
                    "SHA"
                ],
                "duration": 1315
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T11:03:00.000Z",
                "stops": [
                    "DXB",
                    "HKG"
                ],
                "duration": 1522
            }
        ]
    },
    {
        "price": 33781,
        "carrier": "FV",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T03:57:00.000Z",
                "stops": [
                    "KUL",
                    "HKG"
                ],
                "duration": 733
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T10:22:00.000Z",
                "stops": [],
                "duration": 1516
            }
        ]
    },
    {
        "price": 76800,
        "carrier": "MH",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-10T21:02:00.000Z",
                "stops": [],
                "duration": 1357
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T12:10:00.000Z",
                "stops": [
                    "SIN"
                ],
                "duration": 1856
            }
        ]
    },
    {
        "price": 15367,
        "carrier": "SU",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T02:36:00.000Z",
                "stops": [],
                "duration": 1477
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T04:08:00.000Z",
                "stops": [
                    "KUL"
                ],
                "duration": 1963
            }
        ]
    },
    {
        "price": 63893,
        "carrier": "EY",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T15:15:00.000Z",
                "stops": [
                    "SHA",
                    "AUH",
                    "DXB"
                ],
                "duration": 1477
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T05:19:00.000Z",
                "stops": [
                    "IST",
                    "DXB"
                ],
                "duration": 1738
            }
        ]
    },
    {
        "price": 99723,
        "carrier": "TG",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T01:29:00.000Z",
                "stops": [
                    "SIN",
                    "SHA",
                    "HKG"
                ],
                "duration": 1459
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T12:02:00.000Z",
                "stops": [
                    "SHA"
                ],
                "duration": 1326
            }
        ]
    },
    {
        "price": 69519,
        "carrier": "SU",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T12:43:00.000Z",
                "stops": [],
                "duration": 650
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T16:12:00.000Z",
                "stops": [
                    "BKK"
                ],
                "duration": 1467
            }
        ]
    },
    {
        "price": 65679,
        "carrier": "EK",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T02:06:00.000Z",
                "stops": [
                    "BKK",
                    "SIN",
                    "HKG"
                ],
                "duration": 1306
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T01:00:00.000Z",
                "stops": [
                    "DXB"
                ],
                "duration": 1123
            }
        ]
    },
    {
        "price": 27204,
        "carrier": "MH",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T13:46:00.000Z",
                "stops": [
                    "SIN"
                ],
                "duration": 1611
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T03:03:00.000Z",
                "stops": [],
                "duration": 1398
            }
        ]
    },
    {
        "price": 70533,
        "carrier": "S7",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T02:38:00.000Z",
                "stops": [],
                "duration": 1905
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T15:36:00.000Z",
                "stops": [
                    "SIN",
                    "AUH"
                ],
                "duration": 653
            }
        ]
    },
    {
        "price": 80524,
        "carrier": "TG",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T12:16:00.000Z",
                "stops": [
                    "SHA",
                    "DXB"
                ],
                "duration": 668
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T12:28:00.000Z",
                "stops": [
                    "KUL",
                    "SIN",
                    "HKG"
                ],
                "duration": 1421
            }
        ]
    },
    {
        "price": 24788,
        "carrier": "FV",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T06:27:00.000Z",
                "stops": [],
                "duration": 1179
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T08:03:00.000Z",
                "stops": [
                    "BKK",
                    "SIN"
                ],
                "duration": 1235
            }
        ]
    },
    {
        "price": 61299,
        "carrier": "EY",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-10T23:41:00.000Z",
                "stops": [
                    "SHA",
                    "DXB"
                ],
                "duration": 1942
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T10:59:00.000Z",
                "stops": [],
                "duration": 774
            }
        ]
    },
    {
        "price": 65064,
        "carrier": "FV",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T03:08:00.000Z",
                "stops": [
                    "KUL",
                    "BKK",
                    "IST"
                ],
                "duration": 1496
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-30T22:51:00.000Z",
                "stops": [],
                "duration": 1246
            }
        ]
    },
    {
        "price": 99636,
        "carrier": "FV",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T16:13:00.000Z",
                "stops": [
                    "IST",
                    "HKG",
                    "DXB"
                ],
                "duration": 1820
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T15:01:00.000Z",
                "stops": [],
                "duration": 1025
            }
        ]
    },
    {
        "price": 28953,
        "carrier": "MH",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T08:39:00.000Z",
                "stops": [
                    "IST",
                    "SIN",
                    "KUL"
                ],
                "duration": 1135
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T07:00:00.000Z",
                "stops": [],
                "duration": 799
            }
        ]
    },
    {
        "price": 67213,
        "carrier": "EK",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T00:57:00.000Z",
                "stops": [
                    "HKG"
                ],
                "duration": 635
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-30T23:42:00.000Z",
                "stops": [
                    "SIN",
                    "DXB"
                ],
                "duration": 1317
            }
        ]
    },
    {
        "price": 22722,
        "carrier": "MH",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T12:21:00.000Z",
                "stops": [
                    "IST"
                ],
                "duration": 1497
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T11:19:00.000Z",
                "stops": [],
                "duration": 1367
            }
        ]
    },
    {
        "price": 55616,
        "carrier": "SU",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T15:30:00.000Z",
                "stops": [],
                "duration": 1569
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T01:34:00.000Z",
                "stops": [
                    "IST",
                    "SIN"
                ],
                "duration": 801
            }
        ]
    },
    {
        "price": 34031,
        "carrier": "EY",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T06:17:00.000Z",
                "stops": [
                    "DXB"
                ],
                "duration": 1394
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T06:15:00.000Z",
                "stops": [
                    "BKK",
                    "SHA"
                ],
                "duration": 788
            }
        ]
    },
    {
        "price": 21843,
        "carrier": "TG",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T02:51:00.000Z",
                "stops": [
                    "KUL",
                    "IST",
                    "HKG"
                ],
                "duration": 1404
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T08:27:00.000Z",
                "stops": [
                    "HKG"
                ],
                "duration": 788
            }
        ]
    },
    {
        "price": 58440,
        "carrier": "EK",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T04:03:00.000Z",
                "stops": [
                    "BKK"
                ],
                "duration": 1938
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T13:14:00.000Z",
                "stops": [],
                "duration": 860
            }
        ]
    },
    {
        "price": 51300,
        "carrier": "EK",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-10T22:21:00.000Z",
                "stops": [],
                "duration": 1078
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T01:25:00.000Z",
                "stops": [
                    "IST",
                    "BKK",
                    "KUL"
                ],
                "duration": 1575
            }
        ]
    },
    {
        "price": 24642,
        "carrier": "EK",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T16:19:00.000Z",
                "stops": [
                    "KUL",
                    "IST",
                    "HKG"
                ],
                "duration": 1955
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T01:01:00.000Z",
                "stops": [
                    "HKG"
                ],
                "duration": 1838
            }
        ]
    },
    {
        "price": 18628,
        "carrier": "MH",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T09:15:00.000Z",
                "stops": [
                    "DXB",
                    "SHA",
                    "SIN"
                ],
                "duration": 1543
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T10:24:00.000Z",
                "stops": [],
                "duration": 1254
            }
        ]
    },
    {
        "price": 63551,
        "carrier": "S7",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T03:45:00.000Z",
                "stops": [
                    "AUH",
                    "BKK",
                    "SHA"
                ],
                "duration": 1844
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T13:56:00.000Z",
                "stops": [
                    "SHA"
                ],
                "duration": 1304
            }
        ]
    },
    {
        "price": 85704,
        "carrier": "EK",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-10T21:39:00.000Z",
                "stops": [
                    "HKG",
                    "AUH",
                    "BKK"
                ],
                "duration": 1943
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T15:07:00.000Z",
                "stops": [
                    "SIN",
                    "IST",
                    "BKK"
                ],
                "duration": 901
            }
        ]
    },
    {
        "price": 84114,
        "carrier": "MH",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T08:45:00.000Z",
                "stops": [
                    "SHA"
                ],
                "duration": 635
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T17:58:00.000Z",
                "stops": [
                    "IST",
                    "KUL"
                ],
                "duration": 1904
            }
        ]
    },
    {
        "price": 92928,
        "carrier": "MH",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-10T22:40:00.000Z",
                "stops": [
                    "SIN",
                    "KUL"
                ],
                "duration": 828
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T11:57:00.000Z",
                "stops": [
                    "HKG",
                    "BKK"
                ],
                "duration": 1320
            }
        ]
    },
    {
        "price": 23712,
        "carrier": "MH",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T02:35:00.000Z",
                "stops": [
                    "BKK",
                    "SHA",
                    "SIN"
                ],
                "duration": 1954
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T03:06:00.000Z",
                "stops": [
                    "AUH",
                    "DXB",
                    "BKK"
                ],
                "duration": 819
            }
        ]
    },
    {
        "price": 90866,
        "carrier": "MH",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T16:56:00.000Z",
                "stops": [
                    "HKG",
                    "IST"
                ],
                "duration": 1352
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T01:26:00.000Z",
                "stops": [
                    "SHA"
                ],
                "duration": 904
            }
        ]
    },
    {
        "price": 40547,
        "carrier": "MH",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T02:24:00.000Z",
                "stops": [
                    "SIN",
                    "KUL"
                ],
                "duration": 752
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T04:21:00.000Z",
                "stops": [],
                "duration": 1392
            }
        ]
    },
    {
        "price": 72278,
        "carrier": "EK",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T17:39:00.000Z",
                "stops": [],
                "duration": 1927
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-30T21:46:00.000Z",
                "stops": [
                    "SIN",
                    "HKG",
                    "AUH"
                ],
                "duration": 1423
            }
        ]
    },
    {
        "price": 77656,
        "carrier": "EY",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T14:21:00.000Z",
                "stops": [
                    "KUL",
                    "BKK",
                    "SHA"
                ],
                "duration": 792
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T00:42:00.000Z",
                "stops": [],
                "duration": 1719
            }
        ]
    },
    {
        "price": 31166,
        "carrier": "EY",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T14:06:00.000Z",
                "stops": [
                    "DXB"
                ],
                "duration": 1524
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T07:12:00.000Z",
                "stops": [],
                "duration": 1722
            }
        ]
    },
    {
        "price": 60029,
        "carrier": "MH",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T00:49:00.000Z",
                "stops": [
                    "KUL",
                    "AUH"
                ],
                "duration": 1542
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T08:28:00.000Z",
                "stops": [
                    "BKK",
                    "AUH"
                ],
                "duration": 1760
            }
        ]
    },
    {
        "price": 35255,
        "carrier": "TG",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T04:46:00.000Z",
                "stops": [
                    "DXB",
                    "KUL"
                ],
                "duration": 676
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T01:05:00.000Z",
                "stops": [
                    "IST"
                ],
                "duration": 1674
            }
        ]
    },
    {
        "price": 54475,
        "carrier": "S7",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T16:35:00.000Z",
                "stops": [
                    "IST"
                ],
                "duration": 807
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T14:11:00.000Z",
                "stops": [
                    "SIN",
                    "BKK",
                    "HKG"
                ],
                "duration": 1800
            }
        ]
    },
    {
        "price": 22260,
        "carrier": "TG",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T17:34:00.000Z",
                "stops": [
                    "IST",
                    "AUH",
                    "SIN"
                ],
                "duration": 1148
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T05:26:00.000Z",
                "stops": [],
                "duration": 1635
            }
        ]
    },
    {
        "price": 44342,
        "carrier": "S7",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T15:56:00.000Z",
                "stops": [
                    "AUH"
                ],
                "duration": 973
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T10:22:00.000Z",
                "stops": [],
                "duration": 797
            }
        ]
    },
    {
        "price": 73609,
        "carrier": "S7",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T16:28:00.000Z",
                "stops": [
                    "KUL",
                    "SHA",
                    "SIN"
                ],
                "duration": 1596
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T13:30:00.000Z",
                "stops": [
                    "BKK"
                ],
                "duration": 1780
            }
        ]
    },
    {
        "price": 65920,
        "carrier": "EK",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T08:43:00.000Z",
                "stops": [],
                "duration": 1173
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T04:04:00.000Z",
                "stops": [
                    "KUL",
                    "DXB"
                ],
                "duration": 768
            }
        ]
    },
    {
        "price": 78096,
        "carrier": "S7",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T09:04:00.000Z",
                "stops": [
                    "KUL",
                    "IST",
                    "SIN"
                ],
                "duration": 814
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T01:47:00.000Z",
                "stops": [
                    "SIN",
                    "SHA",
                    "BKK"
                ],
                "duration": 1501
            }
        ]
    },
    {
        "price": 34502,
        "carrier": "FV",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T04:40:00.000Z",
                "stops": [
                    "IST"
                ],
                "duration": 1396
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-30T21:44:00.000Z",
                "stops": [
                    "SHA",
                    "BKK",
                    "HKG"
                ],
                "duration": 933
            }
        ]
    },
    {
        "price": 83214,
        "carrier": "TG",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T01:08:00.000Z",
                "stops": [
                    "AUH"
                ],
                "duration": 891
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T03:54:00.000Z",
                "stops": [],
                "duration": 1729
            }
        ]
    },
    {
        "price": 16093,
        "carrier": "TG",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-10T23:26:00.000Z",
                "stops": [
                    "BKK"
                ],
                "duration": 957
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-30T23:00:00.000Z",
                "stops": [],
                "duration": 1119
            }
        ]
    },
    {
        "price": 17116,
        "carrier": "FV",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T16:03:00.000Z",
                "stops": [
                    "SIN",
                    "DXB"
                ],
                "duration": 1216
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T14:03:00.000Z",
                "stops": [
                    "SIN",
                    "AUH"
                ],
                "duration": 1043
            }
        ]
    },
    {
        "price": 40988,
        "carrier": "SU",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T06:20:00.000Z",
                "stops": [
                    "BKK"
                ],
                "duration": 1889
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T08:23:00.000Z",
                "stops": [
                    "BKK"
                ],
                "duration": 1498
            }
        ]
    },
    {
        "price": 78631,
        "carrier": "SU",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T06:07:00.000Z",
                "stops": [
                    "KUL",
                    "IST",
                    "SHA"
                ],
                "duration": 1728
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T17:19:00.000Z",
                "stops": [
                    "BKK",
                    "IST"
                ],
                "duration": 911
            }
        ]
    },
    {
        "price": 58570,
        "carrier": "FV",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T09:55:00.000Z",
                "stops": [
                    "AUH",
                    "KUL",
                    "BKK"
                ],
                "duration": 1261
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-30T23:19:00.000Z",
                "stops": [],
                "duration": 1998
            }
        ]
    },
    {
        "price": 16968,
        "carrier": "FV",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-10T23:00:00.000Z",
                "stops": [
                    "SHA"
                ],
                "duration": 1961
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T09:19:00.000Z",
                "stops": [
                    "KUL",
                    "SHA",
                    "HKG"
                ],
                "duration": 789
            }
        ]
    },
    {
        "price": 94877,
        "carrier": "EY",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T16:43:00.000Z",
                "stops": [
                    "SHA"
                ],
                "duration": 1820
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T01:31:00.000Z",
                "stops": [
                    "AUH",
                    "DXB",
                    "IST"
                ],
                "duration": 1432
            }
        ]
    },
    {
        "price": 45447,
        "carrier": "TG",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-10T23:22:00.000Z",
                "stops": [
                    "IST",
                    "BKK"
                ],
                "duration": 1563
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T03:31:00.000Z",
                "stops": [
                    "IST",
                    "SIN"
                ],
                "duration": 1250
            }
        ]
    },
    {
        "price": 91141,
        "carrier": "EY",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T04:28:00.000Z",
                "stops": [
                    "AUH"
                ],
                "duration": 1616
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T05:42:00.000Z",
                "stops": [
                    "IST",
                    "DXB"
                ],
                "duration": 1394
            }
        ]
    },
    {
        "price": 43245,
        "carrier": "S7",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T14:25:00.000Z",
                "stops": [
                    "SHA",
                    "AUH"
                ],
                "duration": 1081
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T10:20:00.000Z",
                "stops": [
                    "IST",
                    "SIN",
                    "DXB"
                ],
                "duration": 747
            }
        ]
    },
    {
        "price": 56085,
        "carrier": "EY",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T09:00:00.000Z",
                "stops": [
                    "HKG",
                    "SIN",
                    "KUL"
                ],
                "duration": 1286
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T17:57:00.000Z",
                "stops": [
                    "KUL"
                ],
                "duration": 1322
            }
        ]
    },
    {
        "price": 17862,
        "carrier": "EK",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T16:25:00.000Z",
                "stops": [
                    "IST"
                ],
                "duration": 1140
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T14:30:00.000Z",
                "stops": [
                    "IST",
                    "SHA"
                ],
                "duration": 834
            }
        ]
    },
    {
        "price": 59054,
        "carrier": "MH",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T10:54:00.000Z",
                "stops": [
                    "HKG",
                    "AUH"
                ],
                "duration": 1567
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T13:47:00.000Z",
                "stops": [
                    "DXB",
                    "BKK",
                    "AUH"
                ],
                "duration": 1079
            }
        ]
    },
    {
        "price": 46483,
        "carrier": "TG",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-10T21:58:00.000Z",
                "stops": [
                    "SHA",
                    "HKG"
                ],
                "duration": 1947
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T12:30:00.000Z",
                "stops": [
                    "KUL",
                    "SHA",
                    "BKK"
                ],
                "duration": 1778
            }
        ]
    },
    {
        "price": 55648,
        "carrier": "EY",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T14:23:00.000Z",
                "stops": [
                    "KUL"
                ],
                "duration": 753
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T05:47:00.000Z",
                "stops": [
                    "SHA"
                ],
                "duration": 1421
            }
        ]
    },
    {
        "price": 20222,
        "carrier": "EK",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T11:53:00.000Z",
                "stops": [
                    "SIN",
                    "HKG"
                ],
                "duration": 608
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T15:09:00.000Z",
                "stops": [],
                "duration": 1966
            }
        ]
    },
    {
        "price": 76898,
        "carrier": "FV",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-10T21:32:00.000Z",
                "stops": [
                    "KUL"
                ],
                "duration": 1571
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T06:41:00.000Z",
                "stops": [
                    "IST",
                    "BKK",
                    "DXB"
                ],
                "duration": 1917
            }
        ]
    },
    {
        "price": 59417,
        "carrier": "EY",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T10:23:00.000Z",
                "stops": [],
                "duration": 1039
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T05:51:00.000Z",
                "stops": [
                    "DXB",
                    "HKG",
                    "BKK"
                ],
                "duration": 954
            }
        ]
    },
    {
        "price": 39908,
        "carrier": "MH",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-10T23:52:00.000Z",
                "stops": [
                    "KUL"
                ],
                "duration": 1398
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T10:50:00.000Z",
                "stops": [
                    "IST",
                    "DXB",
                    "AUH"
                ],
                "duration": 1776
            }
        ]
    },
    {
        "price": 38518,
        "carrier": "EK",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T00:20:00.000Z",
                "stops": [
                    "DXB"
                ],
                "duration": 1731
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-30T22:25:00.000Z",
                "stops": [
                    "DXB",
                    "AUH"
                ],
                "duration": 1512
            }
        ]
    },
    {
        "price": 42135,
        "carrier": "FV",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T13:06:00.000Z",
                "stops": [],
                "duration": 1577
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-30T21:23:00.000Z",
                "stops": [
                    "BKK",
                    "IST",
                    "DXB"
                ],
                "duration": 1859
            }
        ]
    },
    {
        "price": 43220,
        "carrier": "SU",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T09:24:00.000Z",
                "stops": [
                    "AUH",
                    "HKG"
                ],
                "duration": 1751
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T04:07:00.000Z",
                "stops": [
                    "DXB",
                    "SHA"
                ],
                "duration": 962
            }
        ]
    },
    {
        "price": 68446,
        "carrier": "FV",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T16:29:00.000Z",
                "stops": [
                    "HKG"
                ],
                "duration": 777
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-30T22:20:00.000Z",
                "stops": [
                    "AUH"
                ],
                "duration": 1359
            }
        ]
    },
    {
        "price": 88279,
        "carrier": "S7",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T11:06:00.000Z",
                "stops": [
                    "HKG",
                    "KUL"
                ],
                "duration": 1543
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T14:27:00.000Z",
                "stops": [],
                "duration": 1890
            }
        ]
    },
    {
        "price": 41096,
        "carrier": "TG",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T17:13:00.000Z",
                "stops": [
                    "SHA",
                    "HKG"
                ],
                "duration": 832
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T09:09:00.000Z",
                "stops": [
                    "SHA",
                    "IST",
                    "SIN"
                ],
                "duration": 1437
            }
        ]
    },
    {
        "price": 55444,
        "carrier": "EK",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T03:57:00.000Z",
                "stops": [
                    "AUH",
                    "DXB"
                ],
                "duration": 858
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T02:00:00.000Z",
                "stops": [],
                "duration": 1262
            }
        ]
    },
    {
        "price": 59514,
        "carrier": "FV",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T12:07:00.000Z",
                "stops": [
                    "KUL",
                    "IST"
                ],
                "duration": 1886
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T06:23:00.000Z",
                "stops": [
                    "SHA",
                    "HKG"
                ],
                "duration": 992
            }
        ]
    },
    {
        "price": 44028,
        "carrier": "EY",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T12:37:00.000Z",
                "stops": [
                    "IST",
                    "HKG"
                ],
                "duration": 1358
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T08:40:00.000Z",
                "stops": [
                    "SHA",
                    "HKG",
                    "DXB"
                ],
                "duration": 1056
            }
        ]
    },
    {
        "price": 66628,
        "carrier": "SU",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-10T22:26:00.000Z",
                "stops": [],
                "duration": 1404
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-30T21:26:00.000Z",
                "stops": [
                    "DXB",
                    "HKG"
                ],
                "duration": 625
            }
        ]
    },
    {
        "price": 56105,
        "carrier": "FV",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T08:45:00.000Z",
                "stops": [
                    "KUL",
                    "BKK"
                ],
                "duration": 962
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-30T23:15:00.000Z",
                "stops": [],
                "duration": 1640
            }
        ]
    },
    {
        "price": 25041,
        "carrier": "MH",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T02:21:00.000Z",
                "stops": [],
                "duration": 1136
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T06:41:00.000Z",
                "stops": [
                    "AUH",
                    "HKG",
                    "SHA"
                ],
                "duration": 1213
            }
        ]
    },
    {
        "price": 15785,
        "carrier": "FV",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T02:00:00.000Z",
                "stops": [
                    "SHA"
                ],
                "duration": 1626
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-30T21:58:00.000Z",
                "stops": [
                    "DXB",
                    "IST"
                ],
                "duration": 1179
            }
        ]
    },
    {
        "price": 19227,
        "carrier": "EK",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T00:26:00.000Z",
                "stops": [
                    "KUL",
                    "HKG",
                    "SHA"
                ],
                "duration": 800
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T10:57:00.000Z",
                "stops": [
                    "IST",
                    "DXB"
                ],
                "duration": 1571
            }
        ]
    },
    {
        "price": 54894,
        "carrier": "EK",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T16:37:00.000Z",
                "stops": [
                    "SIN"
                ],
                "duration": 640
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T13:36:00.000Z",
                "stops": [
                    "BKK",
                    "SIN",
                    "KUL"
                ],
                "duration": 782
            }
        ]
    },
    {
        "price": 52952,
        "carrier": "FV",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-10T22:44:00.000Z",
                "stops": [
                    "DXB",
                    "BKK"
                ],
                "duration": 987
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T17:08:00.000Z",
                "stops": [
                    "SHA"
                ],
                "duration": 1427
            }
        ]
    },
    {
        "price": 20140,
        "carrier": "FV",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T06:59:00.000Z",
                "stops": [
                    "SHA",
                    "SIN",
                    "AUH"
                ],
                "duration": 1789
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T06:26:00.000Z",
                "stops": [
                    "SHA",
                    "DXB"
                ],
                "duration": 1345
            }
        ]
    },
    {
        "price": 18871,
        "carrier": "FV",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T07:10:00.000Z",
                "stops": [
                    "IST",
                    "SHA",
                    "AUH"
                ],
                "duration": 1313
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T07:19:00.000Z",
                "stops": [
                    "SIN",
                    "KUL",
                    "HKG"
                ],
                "duration": 847
            }
        ]
    },
    {
        "price": 68487,
        "carrier": "MH",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T09:44:00.000Z",
                "stops": [
                    "AUH",
                    "HKG",
                    "DXB"
                ],
                "duration": 1026
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T10:57:00.000Z",
                "stops": [],
                "duration": 893
            }
        ]
    },
    {
        "price": 49600,
        "carrier": "FV",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-10T23:27:00.000Z",
                "stops": [
                    "SIN",
                    "AUH",
                    "HKG"
                ],
                "duration": 1374
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-30T22:42:00.000Z",
                "stops": [
                    "KUL",
                    "HKG",
                    "IST"
                ],
                "duration": 1951
            }
        ]
    },
    {
        "price": 92435,
        "carrier": "S7",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T00:54:00.000Z",
                "stops": [],
                "duration": 1332
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T11:22:00.000Z",
                "stops": [
                    "SHA",
                    "DXB"
                ],
                "duration": 674
            }
        ]
    },
    {
        "price": 32165,
        "carrier": "S7",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T12:04:00.000Z",
                "stops": [
                    "BKK",
                    "KUL",
                    "SIN"
                ],
                "duration": 1254
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T17:09:00.000Z",
                "stops": [],
                "duration": 1264
            }
        ]
    },
    {
        "price": 73608,
        "carrier": "EY",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T07:10:00.000Z",
                "stops": [],
                "duration": 1400
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T11:38:00.000Z",
                "stops": [
                    "HKG",
                    "DXB",
                    "SIN"
                ],
                "duration": 1808
            }
        ]
    },
    {
        "price": 71702,
        "carrier": "FV",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T03:26:00.000Z",
                "stops": [
                    "KUL",
                    "HKG",
                    "BKK"
                ],
                "duration": 1526
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T02:41:00.000Z",
                "stops": [
                    "BKK",
                    "DXB"
                ],
                "duration": 988
            }
        ]
    },
    {
        "price": 22155,
        "carrier": "TG",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T03:45:00.000Z",
                "stops": [],
                "duration": 841
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T06:23:00.000Z",
                "stops": [],
                "duration": 963
            }
        ]
    },
    {
        "price": 65297,
        "carrier": "SU",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T13:19:00.000Z",
                "stops": [
                    "SHA",
                    "AUH"
                ],
                "duration": 1221
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-30T22:35:00.000Z",
                "stops": [],
                "duration": 1431
            }
        ]
    },
    {
        "price": 77271,
        "carrier": "EK",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T05:48:00.000Z",
                "stops": [
                    "IST",
                    "KUL",
                    "SHA"
                ],
                "duration": 1298
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T10:47:00.000Z",
                "stops": [],
                "duration": 847
            }
        ]
    },
    {
        "price": 49704,
        "carrier": "S7",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T06:48:00.000Z",
                "stops": [
                    "KUL",
                    "AUH"
                ],
                "duration": 1578
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T11:05:00.000Z",
                "stops": [
                    "SHA",
                    "HKG"
                ],
                "duration": 754
            }
        ]
    },
    {
        "price": 29407,
        "carrier": "S7",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T02:35:00.000Z",
                "stops": [
                    "SIN"
                ],
                "duration": 1557
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T00:35:00.000Z",
                "stops": [
                    "BKK"
                ],
                "duration": 1435
            }
        ]
    },
    {
        "price": 52378,
        "carrier": "EY",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T03:35:00.000Z",
                "stops": [
                    "BKK"
                ],
                "duration": 1695
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T16:46:00.000Z",
                "stops": [
                    "DXB",
                    "SIN"
                ],
                "duration": 949
            }
        ]
    },
    {
        "price": 53469,
        "carrier": "EK",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-10T21:00:00.000Z",
                "stops": [],
                "duration": 1721
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-30T22:22:00.000Z",
                "stops": [
                    "IST",
                    "SHA"
                ],
                "duration": 816
            }
        ]
    },
    {
        "price": 68998,
        "carrier": "S7",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T04:50:00.000Z",
                "stops": [],
                "duration": 685
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T08:58:00.000Z",
                "stops": [
                    "BKK"
                ],
                "duration": 1032
            }
        ]
    },
    {
        "price": 84787,
        "carrier": "TG",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T11:31:00.000Z",
                "stops": [
                    "SHA",
                    "SIN"
                ],
                "duration": 1619
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-30T21:16:00.000Z",
                "stops": [
                    "AUH"
                ],
                "duration": 651
            }
        ]
    },
    {
        "price": 52922,
        "carrier": "MH",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T01:14:00.000Z",
                "stops": [],
                "duration": 889
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T08:06:00.000Z",
                "stops": [],
                "duration": 1883
            }
        ]
    },
    {
        "price": 84576,
        "carrier": "EY",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-10T22:20:00.000Z",
                "stops": [],
                "duration": 1486
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T10:49:00.000Z",
                "stops": [
                    "IST"
                ],
                "duration": 1864
            }
        ]
    },
    {
        "price": 57188,
        "carrier": "MH",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-10T21:39:00.000Z",
                "stops": [
                    "BKK"
                ],
                "duration": 1430
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T12:19:00.000Z",
                "stops": [
                    "IST",
                    "SHA",
                    "DXB"
                ],
                "duration": 1920
            }
        ]
    },
    {
        "price": 88512,
        "carrier": "MH",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T16:07:00.000Z",
                "stops": [
                    "HKG",
                    "SHA"
                ],
                "duration": 1210
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T10:05:00.000Z",
                "stops": [
                    "SIN",
                    "IST",
                    "HKG"
                ],
                "duration": 1439
            }
        ]
    },
    {
        "price": 47849,
        "carrier": "SU",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T09:21:00.000Z",
                "stops": [
                    "SIN",
                    "AUH",
                    "IST"
                ],
                "duration": 1492
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T08:45:00.000Z",
                "stops": [
                    "DXB",
                    "BKK",
                    "SIN"
                ],
                "duration": 1046
            }
        ]
    },
    {
        "price": 52155,
        "carrier": "FV",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T06:27:00.000Z",
                "stops": [
                    "AUH",
                    "DXB"
                ],
                "duration": 1658
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T14:30:00.000Z",
                "stops": [
                    "DXB",
                    "SHA"
                ],
                "duration": 1958
            }
        ]
    },
    {
        "price": 67940,
        "carrier": "EK",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T04:05:00.000Z",
                "stops": [],
                "duration": 654
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T06:23:00.000Z",
                "stops": [],
                "duration": 1537
            }
        ]
    },
    {
        "price": 73320,
        "carrier": "TG",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-10T22:49:00.000Z",
                "stops": [
                    "IST",
                    "SHA"
                ],
                "duration": 1740
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T15:12:00.000Z",
                "stops": [
                    "SIN",
                    "SHA",
                    "DXB"
                ],
                "duration": 1491
            }
        ]
    },
    {
        "price": 83030,
        "carrier": "SU",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T16:18:00.000Z",
                "stops": [
                    "IST",
                    "HKG"
                ],
                "duration": 1271
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T09:46:00.000Z",
                "stops": [
                    "IST",
                    "DXB"
                ],
                "duration": 1973
            }
        ]
    },
    {
        "price": 99015,
        "carrier": "MH",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T14:25:00.000Z",
                "stops": [
                    "BKK",
                    "AUH",
                    "DXB"
                ],
                "duration": 1834
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T05:39:00.000Z",
                "stops": [],
                "duration": 1258
            }
        ]
    },
    {
        "price": 32730,
        "carrier": "EK",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T05:08:00.000Z",
                "stops": [
                    "SIN",
                    "SHA",
                    "KUL"
                ],
                "duration": 1822
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T10:25:00.000Z",
                "stops": [
                    "SHA",
                    "IST"
                ],
                "duration": 1116
            }
        ]
    },
    {
        "price": 80271,
        "carrier": "EK",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T17:52:00.000Z",
                "stops": [
                    "BKK",
                    "AUH"
                ],
                "duration": 1417
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T00:24:00.000Z",
                "stops": [
                    "AUH"
                ],
                "duration": 1158
            }
        ]
    },
    {
        "price": 80185,
        "carrier": "SU",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T12:32:00.000Z",
                "stops": [],
                "duration": 1186
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T07:50:00.000Z",
                "stops": [
                    "KUL",
                    "IST"
                ],
                "duration": 1600
            }
        ]
    },
    {
        "price": 91095,
        "carrier": "S7",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T03:03:00.000Z",
                "stops": [],
                "duration": 895
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-30T21:20:00.000Z",
                "stops": [],
                "duration": 1154
            }
        ]
    },
    {
        "price": 70552,
        "carrier": "TG",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T06:03:00.000Z",
                "stops": [
                    "IST",
                    "AUH"
                ],
                "duration": 1656
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T11:25:00.000Z",
                "stops": [
                    "SIN",
                    "SHA"
                ],
                "duration": 631
            }
        ]
    },
    {
        "price": 16638,
        "carrier": "EK",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T04:32:00.000Z",
                "stops": [],
                "duration": 1326
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T11:45:00.000Z",
                "stops": [
                    "HKG"
                ],
                "duration": 1670
            }
        ]
    },
    {
        "price": 53475,
        "carrier": "S7",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T10:12:00.000Z",
                "stops": [
                    "IST",
                    "SIN",
                    "DXB"
                ],
                "duration": 1351
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T16:07:00.000Z",
                "stops": [
                    "SHA"
                ],
                "duration": 649
            }
        ]
    },
    {
        "price": 18371,
        "carrier": "EK",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T06:57:00.000Z",
                "stops": [
                    "SIN",
                    "KUL"
                ],
                "duration": 1978
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T03:24:00.000Z",
                "stops": [
                    "SIN"
                ],
                "duration": 850
            }
        ]
    },
    {
        "price": 69140,
        "carrier": "EK",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T14:46:00.000Z",
                "stops": [
                    "KUL",
                    "IST",
                    "DXB"
                ],
                "duration": 1143
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T02:27:00.000Z",
                "stops": [
                    "AUH"
                ],
                "duration": 1156
            }
        ]
    },
    {
        "price": 50651,
        "carrier": "S7",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T16:50:00.000Z",
                "stops": [
                    "AUH",
                    "SIN",
                    "BKK"
                ],
                "duration": 1869
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T00:50:00.000Z",
                "stops": [],
                "duration": 1271
            }
        ]
    },
    {
        "price": 46647,
        "carrier": "MH",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T17:59:00.000Z",
                "stops": [
                    "SHA",
                    "KUL",
                    "HKG"
                ],
                "duration": 1448
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T10:29:00.000Z",
                "stops": [],
                "duration": 1458
            }
        ]
    },
    {
        "price": 40731,
        "carrier": "TG",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T00:50:00.000Z",
                "stops": [],
                "duration": 1462
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T11:34:00.000Z",
                "stops": [],
                "duration": 1515
            }
        ]
    },
    {
        "price": 64411,
        "carrier": "MH",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T17:14:00.000Z",
                "stops": [
                    "SIN",
                    "KUL",
                    "IST"
                ],
                "duration": 650
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T17:01:00.000Z",
                "stops": [
                    "BKK",
                    "SIN",
                    "SHA"
                ],
                "duration": 1453
            }
        ]
    },
    {
        "price": 84189,
        "carrier": "EY",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T17:10:00.000Z",
                "stops": [],
                "duration": 1249
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T10:36:00.000Z",
                "stops": [
                    "KUL",
                    "SHA",
                    "IST"
                ],
                "duration": 1729
            }
        ]
    },
    {
        "price": 93349,
        "carrier": "FV",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T01:27:00.000Z",
                "stops": [],
                "duration": 1966
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-30T23:11:00.000Z",
                "stops": [
                    "SIN"
                ],
                "duration": 1679
            }
        ]
    },
    {
        "price": 19083,
        "carrier": "MH",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T16:25:00.000Z",
                "stops": [
                    "AUH",
                    "SHA"
                ],
                "duration": 1995
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T04:45:00.000Z",
                "stops": [
                    "HKG",
                    "SIN",
                    "SHA"
                ],
                "duration": 996
            }
        ]
    },
    {
        "price": 93060,
        "carrier": "MH",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T13:48:00.000Z",
                "stops": [
                    "KUL",
                    "IST",
                    "DXB"
                ],
                "duration": 1618
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T07:49:00.000Z",
                "stops": [
                    "SIN",
                    "DXB"
                ],
                "duration": 620
            }
        ]
    },
    {
        "price": 15394,
        "carrier": "FV",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T17:44:00.000Z",
                "stops": [],
                "duration": 960
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T13:11:00.000Z",
                "stops": [],
                "duration": 1060
            }
        ]
    },
    {
        "price": 31307,
        "carrier": "MH",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T15:53:00.000Z",
                "stops": [],
                "duration": 838
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T00:22:00.000Z",
                "stops": [],
                "duration": 1521
            }
        ]
    },
    {
        "price": 47468,
        "carrier": "MH",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T10:38:00.000Z",
                "stops": [],
                "duration": 1928
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T12:52:00.000Z",
                "stops": [
                    "IST",
                    "SIN",
                    "SHA"
                ],
                "duration": 1498
            }
        ]
    },
    {
        "price": 71568,
        "carrier": "S7",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T07:53:00.000Z",
                "stops": [
                    "DXB",
                    "AUH",
                    "KUL"
                ],
                "duration": 1550
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-30T23:41:00.000Z",
                "stops": [],
                "duration": 1557
            }
        ]
    },
    {
        "price": 26451,
        "carrier": "MH",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-10T22:36:00.000Z",
                "stops": [
                    "BKK",
                    "HKG",
                    "SIN"
                ],
                "duration": 1554
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T09:17:00.000Z",
                "stops": [],
                "duration": 1262
            }
        ]
    },
    {
        "price": 43434,
        "carrier": "S7",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-10T21:28:00.000Z",
                "stops": [
                    "SHA",
                    "KUL",
                    "HKG"
                ],
                "duration": 1662
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-30T22:55:00.000Z",
                "stops": [
                    "AUH"
                ],
                "duration": 1533
            }
        ]
    },
    {
        "price": 40084,
        "carrier": "SU",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-10T23:14:00.000Z",
                "stops": [
                    "SIN",
                    "DXB"
                ],
                "duration": 1768
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T02:17:00.000Z",
                "stops": [
                    "DXB",
                    "AUH"
                ],
                "duration": 965
            }
        ]
    },
    {
        "price": 31643,
        "carrier": "SU",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T03:53:00.000Z",
                "stops": [
                    "SHA"
                ],
                "duration": 991
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T02:23:00.000Z",
                "stops": [],
                "duration": 952
            }
        ]
    },
    {
        "price": 78062,
        "carrier": "EK",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T07:48:00.000Z",
                "stops": [
                    "KUL"
                ],
                "duration": 605
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-30T22:57:00.000Z",
                "stops": [
                    "KUL"
                ],
                "duration": 1148
            }
        ]
    },
    {
        "price": 56773,
        "carrier": "EK",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T06:31:00.000Z",
                "stops": [
                    "SHA"
                ],
                "duration": 1539
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-30T22:10:00.000Z",
                "stops": [
                    "HKG"
                ],
                "duration": 764
            }
        ]
    },
    {
        "price": 97346,
        "carrier": "EY",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T11:42:00.000Z",
                "stops": [
                    "SIN"
                ],
                "duration": 1614
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T13:15:00.000Z",
                "stops": [
                    "SHA",
                    "AUH",
                    "HKG"
                ],
                "duration": 607
            }
        ]
    },
    {
        "price": 40526,
        "carrier": "TG",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T05:20:00.000Z",
                "stops": [],
                "duration": 1594
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T05:31:00.000Z",
                "stops": [],
                "duration": 1730
            }
        ]
    },
    {
        "price": 17971,
        "carrier": "TG",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T01:04:00.000Z",
                "stops": [
                    "IST",
                    "DXB"
                ],
                "duration": 1325
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T03:06:00.000Z",
                "stops": [
                    "KUL",
                    "BKK"
                ],
                "duration": 828
            }
        ]
    },
    {
        "price": 28380,
        "carrier": "EK",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T00:17:00.000Z",
                "stops": [
                    "IST",
                    "DXB",
                    "BKK"
                ],
                "duration": 723
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T00:25:00.000Z",
                "stops": [],
                "duration": 1727
            }
        ]
    },
    {
        "price": 27029,
        "carrier": "EK",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T07:57:00.000Z",
                "stops": [
                    "SIN",
                    "HKG",
                    "SHA"
                ],
                "duration": 683
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T13:41:00.000Z",
                "stops": [
                    "DXB",
                    "HKG"
                ],
                "duration": 1221
            }
        ]
    },
    {
        "price": 95447,
        "carrier": "FV",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-10T22:45:00.000Z",
                "stops": [
                    "KUL",
                    "HKG",
                    "IST"
                ],
                "duration": 1922
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T14:42:00.000Z",
                "stops": [],
                "duration": 1076
            }
        ]
    },
    {
        "price": 50015,
        "carrier": "TG",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-10T23:48:00.000Z",
                "stops": [
                    "IST",
                    "KUL"
                ],
                "duration": 1352
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T11:21:00.000Z",
                "stops": [],
                "duration": 1731
            }
        ]
    },
    {
        "price": 39257,
        "carrier": "MH",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-10T22:36:00.000Z",
                "stops": [],
                "duration": 665
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T08:56:00.000Z",
                "stops": [
                    "DXB",
                    "KUL"
                ],
                "duration": 1740
            }
        ]
    },
    {
        "price": 50166,
        "carrier": "TG",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T02:00:00.000Z",
                "stops": [
                    "HKG",
                    "BKK",
                    "SHA"
                ],
                "duration": 1250
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T05:47:00.000Z",
                "stops": [
                    "IST",
                    "HKG"
                ],
                "duration": 1676
            }
        ]
    },
    {
        "price": 17228,
        "carrier": "SU",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-10T22:03:00.000Z",
                "stops": [
                    "DXB",
                    "SIN"
                ],
                "duration": 681
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T02:54:00.000Z",
                "stops": [
                    "HKG"
                ],
                "duration": 1764
            }
        ]
    },
    {
        "price": 32951,
        "carrier": "FV",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T16:35:00.000Z",
                "stops": [
                    "SIN"
                ],
                "duration": 911
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T02:07:00.000Z",
                "stops": [
                    "DXB",
                    "HKG",
                    "AUH"
                ],
                "duration": 1435
            }
        ]
    },
    {
        "price": 82988,
        "carrier": "EY",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T17:22:00.000Z",
                "stops": [
                    "DXB",
                    "SIN",
                    "AUH"
                ],
                "duration": 890
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T11:13:00.000Z",
                "stops": [
                    "HKG"
                ],
                "duration": 1551
            }
        ]
    },
    {
        "price": 62703,
        "carrier": "TG",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T05:43:00.000Z",
                "stops": [
                    "KUL"
                ],
                "duration": 1491
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T10:35:00.000Z",
                "stops": [
                    "KUL",
                    "HKG",
                    "BKK"
                ],
                "duration": 1607
            }
        ]
    },
    {
        "price": 94380,
        "carrier": "EK",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T08:11:00.000Z",
                "stops": [
                    "KUL",
                    "SIN"
                ],
                "duration": 934
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T15:36:00.000Z",
                "stops": [
                    "IST",
                    "SHA",
                    "SIN"
                ],
                "duration": 1290
            }
        ]
    },
    {
        "price": 81297,
        "carrier": "EY",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T17:06:00.000Z",
                "stops": [],
                "duration": 928
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-30T22:59:00.000Z",
                "stops": [
                    "KUL",
                    "AUH"
                ],
                "duration": 1389
            }
        ]
    },
    {
        "price": 59549,
        "carrier": "EY",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-10T23:43:00.000Z",
                "stops": [
                    "KUL",
                    "BKK",
                    "AUH"
                ],
                "duration": 1355
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T06:44:00.000Z",
                "stops": [
                    "SHA"
                ],
                "duration": 1315
            }
        ]
    },
    {
        "price": 51929,
        "carrier": "EY",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T16:34:00.000Z",
                "stops": [
                    "BKK"
                ],
                "duration": 1173
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-30T22:28:00.000Z",
                "stops": [
                    "DXB",
                    "HKG"
                ],
                "duration": 1773
            }
        ]
    },
    {
        "price": 58903,
        "carrier": "MH",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T14:15:00.000Z",
                "stops": [],
                "duration": 1724
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T02:18:00.000Z",
                "stops": [
                    "SIN",
                    "DXB"
                ],
                "duration": 817
            }
        ]
    },
    {
        "price": 63149,
        "carrier": "S7",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T03:04:00.000Z",
                "stops": [
                    "BKK"
                ],
                "duration": 1552
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T00:51:00.000Z",
                "stops": [
                    "HKG"
                ],
                "duration": 702
            }
        ]
    },
    {
        "price": 73057,
        "carrier": "TG",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T16:07:00.000Z",
                "stops": [
                    "AUH"
                ],
                "duration": 1915
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T03:38:00.000Z",
                "stops": [
                    "BKK",
                    "AUH",
                    "SHA"
                ],
                "duration": 1865
            }
        ]
    },
    {
        "price": 33322,
        "carrier": "SU",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T05:18:00.000Z",
                "stops": [
                    "SIN",
                    "KUL",
                    "AUH"
                ],
                "duration": 976
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T04:40:00.000Z",
                "stops": [],
                "duration": 1442
            }
        ]
    },
    {
        "price": 21465,
        "carrier": "FV",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T04:07:00.000Z",
                "stops": [],
                "duration": 998
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T05:32:00.000Z",
                "stops": [],
                "duration": 1667
            }
        ]
    },
    {
        "price": 52754,
        "carrier": "S7",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T06:35:00.000Z",
                "stops": [],
                "duration": 677
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T12:57:00.000Z",
                "stops": [
                    "SIN"
                ],
                "duration": 747
            }
        ]
    },
    {
        "price": 80962,
        "carrier": "EK",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-10T23:22:00.000Z",
                "stops": [],
                "duration": 1839
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T05:20:00.000Z",
                "stops": [],
                "duration": 1181
            }
        ]
    },
    {
        "price": 97790,
        "carrier": "EK",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T07:16:00.000Z",
                "stops": [
                    "SHA"
                ],
                "duration": 634
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T11:00:00.000Z",
                "stops": [],
                "duration": 1875
            }
        ]
    },
    {
        "price": 36146,
        "carrier": "TG",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T04:52:00.000Z",
                "stops": [],
                "duration": 717
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T01:09:00.000Z",
                "stops": [
                    "HKG"
                ],
                "duration": 954
            }
        ]
    },
    {
        "price": 60922,
        "carrier": "TG",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T01:27:00.000Z",
                "stops": [
                    "DXB",
                    "SHA",
                    "IST"
                ],
                "duration": 1098
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-30T23:48:00.000Z",
                "stops": [
                    "DXB",
                    "HKG"
                ],
                "duration": 795
            }
        ]
    },
    {
        "price": 74120,
        "carrier": "TG",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T04:16:00.000Z",
                "stops": [],
                "duration": 1922
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T08:23:00.000Z",
                "stops": [
                    "BKK",
                    "AUH"
                ],
                "duration": 1162
            }
        ]
    },
    {
        "price": 59339,
        "carrier": "S7",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T08:52:00.000Z",
                "stops": [
                    "HKG",
                    "AUH",
                    "SHA"
                ],
                "duration": 1354
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T00:06:00.000Z",
                "stops": [
                    "SHA",
                    "HKG",
                    "DXB"
                ],
                "duration": 670
            }
        ]
    },
    {
        "price": 98213,
        "carrier": "EK",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T10:04:00.000Z",
                "stops": [
                    "BKK",
                    "SIN",
                    "HKG"
                ],
                "duration": 1719
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T12:28:00.000Z",
                "stops": [
                    "BKK"
                ],
                "duration": 1311
            }
        ]
    },
    {
        "price": 36265,
        "carrier": "S7",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T00:08:00.000Z",
                "stops": [
                    "AUH",
                    "HKG"
                ],
                "duration": 1438
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T09:02:00.000Z",
                "stops": [
                    "DXB",
                    "KUL"
                ],
                "duration": 864
            }
        ]
    },
    {
        "price": 66240,
        "carrier": "SU",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T15:06:00.000Z",
                "stops": [
                    "IST"
                ],
                "duration": 757
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T15:33:00.000Z",
                "stops": [
                    "SIN"
                ],
                "duration": 1722
            }
        ]
    },
    {
        "price": 72147,
        "carrier": "EK",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T12:16:00.000Z",
                "stops": [
                    "HKG",
                    "DXB"
                ],
                "duration": 1361
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T11:54:00.000Z",
                "stops": [
                    "DXB",
                    "SHA",
                    "KUL"
                ],
                "duration": 1414
            }
        ]
    },
    {
        "price": 33439,
        "carrier": "FV",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T02:36:00.000Z",
                "stops": [
                    "SIN",
                    "IST"
                ],
                "duration": 1995
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T03:47:00.000Z",
                "stops": [],
                "duration": 967
            }
        ]
    },
    {
        "price": 26674,
        "carrier": "SU",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T09:57:00.000Z",
                "stops": [
                    "BKK",
                    "DXB",
                    "SHA"
                ],
                "duration": 1581
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T00:04:00.000Z",
                "stops": [
                    "SHA",
                    "SIN",
                    "KUL"
                ],
                "duration": 1100
            }
        ]
    },
    {
        "price": 88929,
        "carrier": "S7",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T04:07:00.000Z",
                "stops": [
                    "SIN",
                    "SHA",
                    "IST"
                ],
                "duration": 915
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T12:04:00.000Z",
                "stops": [],
                "duration": 748
            }
        ]
    },
    {
        "price": 47422,
        "carrier": "SU",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-10T21:57:00.000Z",
                "stops": [
                    "KUL",
                    "SIN"
                ],
                "duration": 1770
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T01:06:00.000Z",
                "stops": [],
                "duration": 920
            }
        ]
    },
    {
        "price": 25159,
        "carrier": "S7",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T08:32:00.000Z",
                "stops": [
                    "SHA"
                ],
                "duration": 1621
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-30T23:43:00.000Z",
                "stops": [],
                "duration": 1560
            }
        ]
    },
    {
        "price": 20399,
        "carrier": "EK",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T03:07:00.000Z",
                "stops": [],
                "duration": 1437
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T00:34:00.000Z",
                "stops": [],
                "duration": 707
            }
        ]
    },
    {
        "price": 60534,
        "carrier": "EY",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T07:08:00.000Z",
                "stops": [
                    "BKK"
                ],
                "duration": 1566
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T14:07:00.000Z",
                "stops": [
                    "AUH"
                ],
                "duration": 1243
            }
        ]
    },
    {
        "price": 89747,
        "carrier": "SU",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T11:52:00.000Z",
                "stops": [
                    "DXB",
                    "IST",
                    "KUL"
                ],
                "duration": 733
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T14:58:00.000Z",
                "stops": [
                    "AUH"
                ],
                "duration": 918
            }
        ]
    },
    {
        "price": 56701,
        "carrier": "MH",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T07:57:00.000Z",
                "stops": [
                    "IST",
                    "DXB"
                ],
                "duration": 1632
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T05:47:00.000Z",
                "stops": [
                    "SIN",
                    "HKG",
                    "IST"
                ],
                "duration": 797
            }
        ]
    },
    {
        "price": 37096,
        "carrier": "EK",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T02:01:00.000Z",
                "stops": [
                    "KUL",
                    "SIN"
                ],
                "duration": 1777
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T05:49:00.000Z",
                "stops": [
                    "HKG"
                ],
                "duration": 916
            }
        ]
    },
    {
        "price": 80136,
        "carrier": "SU",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T11:06:00.000Z",
                "stops": [],
                "duration": 1947
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T06:20:00.000Z",
                "stops": [
                    "SHA"
                ],
                "duration": 1338
            }
        ]
    },
    {
        "price": 45422,
        "carrier": "MH",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T00:22:00.000Z",
                "stops": [
                    "AUH",
                    "KUL"
                ],
                "duration": 706
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T05:56:00.000Z",
                "stops": [
                    "DXB",
                    "HKG",
                    "BKK"
                ],
                "duration": 1358
            }
        ]
    },
    {
        "price": 79000,
        "carrier": "S7",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T08:00:00.000Z",
                "stops": [
                    "BKK",
                    "KUL"
                ],
                "duration": 1178
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T13:13:00.000Z",
                "stops": [],
                "duration": 1919
            }
        ]
    },
    {
        "price": 88794,
        "carrier": "S7",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T08:48:00.000Z",
                "stops": [
                    "DXB"
                ],
                "duration": 936
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T13:55:00.000Z",
                "stops": [],
                "duration": 1144
            }
        ]
    },
    {
        "price": 60028,
        "carrier": "EY",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-10T21:03:00.000Z",
                "stops": [],
                "duration": 1909
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T07:49:00.000Z",
                "stops": [
                    "DXB",
                    "AUH",
                    "SHA"
                ],
                "duration": 790
            }
        ]
    },
    {
        "price": 90170,
        "carrier": "S7",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T03:58:00.000Z",
                "stops": [],
                "duration": 1644
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T11:35:00.000Z",
                "stops": [
                    "SIN",
                    "AUH"
                ],
                "duration": 1135
            }
        ]
    },
    {
        "price": 35395,
        "carrier": "S7",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T13:06:00.000Z",
                "stops": [
                    "SHA",
                    "BKK"
                ],
                "duration": 1663
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T02:35:00.000Z",
                "stops": [],
                "duration": 1960
            }
        ]
    },
    {
        "price": 23594,
        "carrier": "MH",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T02:23:00.000Z",
                "stops": [
                    "DXB",
                    "AUH",
                    "HKG"
                ],
                "duration": 1174
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-30T21:52:00.000Z",
                "stops": [],
                "duration": 1146
            }
        ]
    },
    {
        "price": 43157,
        "carrier": "FV",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T07:36:00.000Z",
                "stops": [
                    "DXB",
                    "IST",
                    "HKG"
                ],
                "duration": 1306
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T17:18:00.000Z",
                "stops": [],
                "duration": 890
            }
        ]
    },
    {
        "price": 35618,
        "carrier": "S7",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T03:27:00.000Z",
                "stops": [
                    "KUL"
                ],
                "duration": 819
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T00:30:00.000Z",
                "stops": [
                    "DXB"
                ],
                "duration": 1536
            }
        ]
    },
    {
        "price": 99696,
        "carrier": "TG",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T13:59:00.000Z",
                "stops": [
                    "SIN"
                ],
                "duration": 975
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T04:09:00.000Z",
                "stops": [
                    "BKK"
                ],
                "duration": 832
            }
        ]
    },
    {
        "price": 39144,
        "carrier": "TG",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T05:43:00.000Z",
                "stops": [],
                "duration": 666
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T01:31:00.000Z",
                "stops": [
                    "SHA",
                    "DXB",
                    "SIN"
                ],
                "duration": 788
            }
        ]
    },
    {
        "price": 24363,
        "carrier": "EK",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-10T21:46:00.000Z",
                "stops": [
                    "DXB",
                    "SHA",
                    "KUL"
                ],
                "duration": 1950
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T00:52:00.000Z",
                "stops": [],
                "duration": 1830
            }
        ]
    },
    {
        "price": 58504,
        "carrier": "EK",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T16:31:00.000Z",
                "stops": [
                    "BKK"
                ],
                "duration": 1364
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T03:51:00.000Z",
                "stops": [
                    "AUH",
                    "BKK"
                ],
                "duration": 1515
            }
        ]
    },
    {
        "price": 32360,
        "carrier": "SU",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T16:56:00.000Z",
                "stops": [
                    "HKG",
                    "DXB"
                ],
                "duration": 1751
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T11:39:00.000Z",
                "stops": [
                    "SHA",
                    "HKG",
                    "SIN"
                ],
                "duration": 1292
            }
        ]
    },
    {
        "price": 80799,
        "carrier": "TG",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T05:31:00.000Z",
                "stops": [
                    "SHA"
                ],
                "duration": 614
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T03:23:00.000Z",
                "stops": [
                    "BKK",
                    "KUL"
                ],
                "duration": 1680
            }
        ]
    },
    {
        "price": 95507,
        "carrier": "SU",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T12:57:00.000Z",
                "stops": [
                    "KUL"
                ],
                "duration": 901
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T09:37:00.000Z",
                "stops": [
                    "IST",
                    "BKK"
                ],
                "duration": 1601
            }
        ]
    },
    {
        "price": 85414,
        "carrier": "MH",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T13:52:00.000Z",
                "stops": [
                    "BKK"
                ],
                "duration": 1712
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-30T21:02:00.000Z",
                "stops": [],
                "duration": 1106
            }
        ]
    },
    {
        "price": 40003,
        "carrier": "SU",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T06:47:00.000Z",
                "stops": [
                    "SHA",
                    "HKG",
                    "AUH"
                ],
                "duration": 985
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T11:23:00.000Z",
                "stops": [
                    "SHA",
                    "IST"
                ],
                "duration": 1170
            }
        ]
    },
    {
        "price": 65210,
        "carrier": "MH",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T04:30:00.000Z",
                "stops": [
                    "HKG",
                    "AUH",
                    "DXB"
                ],
                "duration": 643
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T08:40:00.000Z",
                "stops": [
                    "AUH",
                    "SIN",
                    "IST"
                ],
                "duration": 1897
            }
        ]
    },
    {
        "price": 58133,
        "carrier": "MH",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T02:47:00.000Z",
                "stops": [
                    "SIN",
                    "HKG",
                    "KUL"
                ],
                "duration": 901
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T14:50:00.000Z",
                "stops": [
                    "SHA"
                ],
                "duration": 1683
            }
        ]
    },
    {
        "price": 81096,
        "carrier": "S7",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T13:51:00.000Z",
                "stops": [],
                "duration": 1493
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T03:57:00.000Z",
                "stops": [
                    "KUL",
                    "AUH"
                ],
                "duration": 1978
            }
        ]
    },
    {
        "price": 20522,
        "carrier": "EY",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T04:36:00.000Z",
                "stops": [
                    "KUL",
                    "BKK",
                    "HKG"
                ],
                "duration": 1160
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-30T22:49:00.000Z",
                "stops": [
                    "KUL"
                ],
                "duration": 614
            }
        ]
    },
    {
        "price": 63565,
        "carrier": "MH",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T15:18:00.000Z",
                "stops": [
                    "BKK",
                    "SHA",
                    "DXB"
                ],
                "duration": 1655
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T04:32:00.000Z",
                "stops": [
                    "SIN"
                ],
                "duration": 1918
            }
        ]
    },
    {
        "price": 49530,
        "carrier": "SU",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T07:04:00.000Z",
                "stops": [
                    "DXB",
                    "KUL"
                ],
                "duration": 735
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T13:16:00.000Z",
                "stops": [
                    "BKK",
                    "KUL",
                    "HKG"
                ],
                "duration": 1429
            }
        ]
    },
    {
        "price": 61093,
        "carrier": "EY",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T11:22:00.000Z",
                "stops": [
                    "KUL"
                ],
                "duration": 1567
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T08:18:00.000Z",
                "stops": [],
                "duration": 1306
            }
        ]
    },
    {
        "price": 26392,
        "carrier": "TG",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-10T21:46:00.000Z",
                "stops": [
                    "BKK",
                    "DXB"
                ],
                "duration": 734
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T16:25:00.000Z",
                "stops": [
                    "SIN"
                ],
                "duration": 965
            }
        ]
    },
    {
        "price": 90707,
        "carrier": "EY",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-10T22:33:00.000Z",
                "stops": [
                    "KUL",
                    "AUH"
                ],
                "duration": 918
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T00:26:00.000Z",
                "stops": [
                    "HKG",
                    "SIN"
                ],
                "duration": 789
            }
        ]
    },
    {
        "price": 51735,
        "carrier": "EK",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T12:02:00.000Z",
                "stops": [
                    "BKK",
                    "IST"
                ],
                "duration": 1801
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T07:06:00.000Z",
                "stops": [
                    "HKG",
                    "KUL",
                    "DXB"
                ],
                "duration": 892
            }
        ]
    },
    {
        "price": 83359,
        "carrier": "FV",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T14:50:00.000Z",
                "stops": [
                    "IST",
                    "HKG"
                ],
                "duration": 1371
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T10:11:00.000Z",
                "stops": [
                    "KUL",
                    "SHA"
                ],
                "duration": 891
            }
        ]
    },
    {
        "price": 99312,
        "carrier": "EY",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-10T22:25:00.000Z",
                "stops": [
                    "KUL"
                ],
                "duration": 1380
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T04:34:00.000Z",
                "stops": [
                    "BKK",
                    "SIN"
                ],
                "duration": 1529
            }
        ]
    },
    {
        "price": 26695,
        "carrier": "S7",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T07:53:00.000Z",
                "stops": [],
                "duration": 1709
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T10:37:00.000Z",
                "stops": [],
                "duration": 763
            }
        ]
    },
    {
        "price": 65379,
        "carrier": "TG",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T07:15:00.000Z",
                "stops": [
                    "SHA",
                    "DXB"
                ],
                "duration": 1912
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T08:45:00.000Z",
                "stops": [],
                "duration": 1792
            }
        ]
    },
    {
        "price": 47842,
        "carrier": "S7",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T02:18:00.000Z",
                "stops": [
                    "AUH",
                    "KUL",
                    "SHA"
                ],
                "duration": 1522
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T14:13:00.000Z",
                "stops": [],
                "duration": 613
            }
        ]
    },
    {
        "price": 64788,
        "carrier": "FV",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T11:39:00.000Z",
                "stops": [],
                "duration": 986
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T04:05:00.000Z",
                "stops": [
                    "AUH",
                    "SIN",
                    "KUL"
                ],
                "duration": 1705
            }
        ]
    },
    {
        "price": 68200,
        "carrier": "FV",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T14:36:00.000Z",
                "stops": [
                    "HKG",
                    "DXB"
                ],
                "duration": 1896
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T10:13:00.000Z",
                "stops": [
                    "HKG",
                    "SIN",
                    "BKK"
                ],
                "duration": 1170
            }
        ]
    },
    {
        "price": 34318,
        "carrier": "TG",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-10T21:48:00.000Z",
                "stops": [
                    "BKK"
                ],
                "duration": 795
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T16:09:00.000Z",
                "stops": [
                    "SIN",
                    "AUH"
                ],
                "duration": 1428
            }
        ]
    },
    {
        "price": 74710,
        "carrier": "SU",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T00:16:00.000Z",
                "stops": [
                    "BKK",
                    "DXB"
                ],
                "duration": 1343
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T11:44:00.000Z",
                "stops": [
                    "SIN",
                    "IST"
                ],
                "duration": 1231
            }
        ]
    },
    {
        "price": 41935,
        "carrier": "SU",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T15:59:00.000Z",
                "stops": [],
                "duration": 722
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T02:51:00.000Z",
                "stops": [
                    "IST"
                ],
                "duration": 831
            }
        ]
    },
    {
        "price": 39527,
        "carrier": "SU",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-10T23:13:00.000Z",
                "stops": [
                    "AUH"
                ],
                "duration": 1878
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T05:37:00.000Z",
                "stops": [
                    "AUH",
                    "DXB",
                    "KUL"
                ],
                "duration": 1991
            }
        ]
    },
    {
        "price": 57455,
        "carrier": "S7",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-10T23:32:00.000Z",
                "stops": [
                    "HKG",
                    "BKK"
                ],
                "duration": 1108
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T00:51:00.000Z",
                "stops": [
                    "SHA",
                    "HKG"
                ],
                "duration": 1695
            }
        ]
    },
    {
        "price": 63406,
        "carrier": "S7",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-10T23:32:00.000Z",
                "stops": [
                    "DXB"
                ],
                "duration": 1750
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T07:30:00.000Z",
                "stops": [
                    "AUH",
                    "BKK",
                    "IST"
                ],
                "duration": 1040
            }
        ]
    },
    {
        "price": 29908,
        "carrier": "FV",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T07:55:00.000Z",
                "stops": [
                    "HKG"
                ],
                "duration": 1391
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T07:57:00.000Z",
                "stops": [
                    "DXB",
                    "AUH",
                    "KUL"
                ],
                "duration": 1523
            }
        ]
    },
    {
        "price": 50936,
        "carrier": "S7",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-10T23:44:00.000Z",
                "stops": [],
                "duration": 1742
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T16:55:00.000Z",
                "stops": [
                    "HKG",
                    "DXB",
                    "AUH"
                ],
                "duration": 907
            }
        ]
    },
    {
        "price": 85520,
        "carrier": "S7",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-10T23:19:00.000Z",
                "stops": [
                    "BKK"
                ],
                "duration": 1899
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-30T23:40:00.000Z",
                "stops": [
                    "IST",
                    "DXB"
                ],
                "duration": 983
            }
        ]
    },
    {
        "price": 43166,
        "carrier": "MH",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-10T22:12:00.000Z",
                "stops": [],
                "duration": 760
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T14:08:00.000Z",
                "stops": [
                    "SIN"
                ],
                "duration": 1184
            }
        ]
    },
    {
        "price": 76341,
        "carrier": "S7",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-10T22:47:00.000Z",
                "stops": [
                    "BKK",
                    "SHA"
                ],
                "duration": 732
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T02:54:00.000Z",
                "stops": [],
                "duration": 1892
            }
        ]
    },
    {
        "price": 83326,
        "carrier": "TG",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T07:45:00.000Z",
                "stops": [
                    "DXB",
                    "BKK",
                    "AUH"
                ],
                "duration": 700
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T11:44:00.000Z",
                "stops": [],
                "duration": 675
            }
        ]
    },
    {
        "price": 35386,
        "carrier": "S7",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T04:40:00.000Z",
                "stops": [
                    "HKG",
                    "SIN"
                ],
                "duration": 665
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T06:36:00.000Z",
                "stops": [
                    "KUL",
                    "SHA",
                    "SIN"
                ],
                "duration": 1271
            }
        ]
    },
    {
        "price": 35454,
        "carrier": "EK",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T03:19:00.000Z",
                "stops": [],
                "duration": 1534
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T05:48:00.000Z",
                "stops": [],
                "duration": 789
            }
        ]
    },
    {
        "price": 38285,
        "carrier": "SU",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T13:13:00.000Z",
                "stops": [],
                "duration": 1895
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T16:29:00.000Z",
                "stops": [],
                "duration": 1189
            }
        ]
    },
    {
        "price": 46330,
        "carrier": "FV",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T10:40:00.000Z",
                "stops": [
                    "HKG"
                ],
                "duration": 710
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-30T22:35:00.000Z",
                "stops": [
                    "HKG"
                ],
                "duration": 1878
            }
        ]
    },
    {
        "price": 79588,
        "carrier": "SU",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T01:28:00.000Z",
                "stops": [
                    "AUH",
                    "HKG",
                    "BKK"
                ],
                "duration": 1846
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T16:25:00.000Z",
                "stops": [
                    "DXB"
                ],
                "duration": 1149
            }
        ]
    },
    {
        "price": 34354,
        "carrier": "EY",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T16:48:00.000Z",
                "stops": [
                    "KUL",
                    "DXB",
                    "HKG"
                ],
                "duration": 1068
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T11:51:00.000Z",
                "stops": [
                    "AUH"
                ],
                "duration": 1751
            }
        ]
    },
    {
        "price": 91018,
        "carrier": "MH",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T09:39:00.000Z",
                "stops": [
                    "SHA",
                    "KUL",
                    "IST"
                ],
                "duration": 1618
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-30T23:32:00.000Z",
                "stops": [
                    "KUL",
                    "AUH"
                ],
                "duration": 892
            }
        ]
    },
    {
        "price": 58239,
        "carrier": "S7",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T09:54:00.000Z",
                "stops": [
                    "SIN",
                    "HKG",
                    "SHA"
                ],
                "duration": 1326
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T05:30:00.000Z",
                "stops": [
                    "BKK",
                    "IST"
                ],
                "duration": 669
            }
        ]
    },
    {
        "price": 84479,
        "carrier": "S7",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-10T22:42:00.000Z",
                "stops": [],
                "duration": 1555
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T14:08:00.000Z",
                "stops": [],
                "duration": 827
            }
        ]
    },
    {
        "price": 64481,
        "carrier": "SU",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T04:00:00.000Z",
                "stops": [],
                "duration": 1499
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T01:24:00.000Z",
                "stops": [
                    "HKG",
                    "AUH",
                    "IST"
                ],
                "duration": 1441
            }
        ]
    },
    {
        "price": 29013,
        "carrier": "FV",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-10T21:13:00.000Z",
                "stops": [
                    "IST"
                ],
                "duration": 1175
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T02:50:00.000Z",
                "stops": [
                    "KUL",
                    "HKG",
                    "SIN"
                ],
                "duration": 1753
            }
        ]
    },
    {
        "price": 24711,
        "carrier": "SU",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T13:04:00.000Z",
                "stops": [],
                "duration": 1349
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T09:31:00.000Z",
                "stops": [
                    "AUH",
                    "HKG"
                ],
                "duration": 826
            }
        ]
    },
    {
        "price": 73222,
        "carrier": "EY",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T01:35:00.000Z",
                "stops": [
                    "IST"
                ],
                "duration": 1971
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T12:20:00.000Z",
                "stops": [
                    "IST",
                    "AUH"
                ],
                "duration": 1569
            }
        ]
    },
    {
        "price": 26022,
        "carrier": "S7",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T02:35:00.000Z",
                "stops": [],
                "duration": 1174
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-30T21:45:00.000Z",
                "stops": [
                    "SHA"
                ],
                "duration": 1135
            }
        ]
    },
    {
        "price": 66595,
        "carrier": "SU",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-10T23:33:00.000Z",
                "stops": [
                    "SHA",
                    "KUL"
                ],
                "duration": 1194
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-30T21:31:00.000Z",
                "stops": [
                    "IST",
                    "SHA",
                    "DXB"
                ],
                "duration": 1830
            }
        ]
    },
    {
        "price": 70650,
        "carrier": "FV",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T12:51:00.000Z",
                "stops": [
                    "DXB",
                    "IST"
                ],
                "duration": 707
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T12:38:00.000Z",
                "stops": [
                    "KUL",
                    "AUH",
                    "DXB"
                ],
                "duration": 1853
            }
        ]
    },
    {
        "price": 19198,
        "carrier": "FV",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T11:46:00.000Z",
                "stops": [
                    "HKG"
                ],
                "duration": 1628
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T02:19:00.000Z",
                "stops": [
                    "BKK",
                    "AUH"
                ],
                "duration": 1423
            }
        ]
    },
    {
        "price": 89589,
        "carrier": "EK",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T02:27:00.000Z",
                "stops": [],
                "duration": 748
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T03:07:00.000Z",
                "stops": [
                    "BKK"
                ],
                "duration": 1724
            }
        ]
    },
    {
        "price": 94920,
        "carrier": "EY",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T15:34:00.000Z",
                "stops": [
                    "SHA",
                    "KUL",
                    "SIN"
                ],
                "duration": 647
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T07:24:00.000Z",
                "stops": [
                    "HKG",
                    "SIN"
                ],
                "duration": 1774
            }
        ]
    },
    {
        "price": 90472,
        "carrier": "MH",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T12:43:00.000Z",
                "stops": [
                    "KUL",
                    "SIN"
                ],
                "duration": 1278
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T06:04:00.000Z",
                "stops": [
                    "HKG",
                    "SHA"
                ],
                "duration": 1811
            }
        ]
    },
    {
        "price": 83549,
        "carrier": "MH",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T07:56:00.000Z",
                "stops": [
                    "AUH",
                    "HKG"
                ],
                "duration": 856
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T15:35:00.000Z",
                "stops": [
                    "AUH",
                    "SHA"
                ],
                "duration": 1405
            }
        ]
    },
    {
        "price": 37081,
        "carrier": "EY",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T00:12:00.000Z",
                "stops": [
                    "IST",
                    "KUL"
                ],
                "duration": 1725
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T15:39:00.000Z",
                "stops": [
                    "BKK",
                    "AUH",
                    "KUL"
                ],
                "duration": 1540
            }
        ]
    },
    {
        "price": 63719,
        "carrier": "EY",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T17:37:00.000Z",
                "stops": [
                    "SIN",
                    "AUH"
                ],
                "duration": 1822
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T17:38:00.000Z",
                "stops": [
                    "SHA",
                    "IST",
                    "BKK"
                ],
                "duration": 1915
            }
        ]
    },
    {
        "price": 97017,
        "carrier": "MH",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T00:03:00.000Z",
                "stops": [
                    "SIN",
                    "IST",
                    "HKG"
                ],
                "duration": 1482
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T03:48:00.000Z",
                "stops": [
                    "SHA",
                    "DXB",
                    "SIN"
                ],
                "duration": 1129
            }
        ]
    },
    {
        "price": 89075,
        "carrier": "MH",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T03:28:00.000Z",
                "stops": [
                    "SHA",
                    "SIN",
                    "DXB"
                ],
                "duration": 816
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T06:05:00.000Z",
                "stops": [
                    "SHA"
                ],
                "duration": 648
            }
        ]
    },
    {
        "price": 63335,
        "carrier": "S7",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T05:07:00.000Z",
                "stops": [
                    "IST"
                ],
                "duration": 1965
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T17:56:00.000Z",
                "stops": [
                    "BKK"
                ],
                "duration": 918
            }
        ]
    },
    {
        "price": 83676,
        "carrier": "FV",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-10T22:41:00.000Z",
                "stops": [
                    "BKK",
                    "DXB"
                ],
                "duration": 883
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T16:00:00.000Z",
                "stops": [
                    "SHA",
                    "HKG",
                    "AUH"
                ],
                "duration": 1728
            }
        ]
    },
    {
        "price": 27962,
        "carrier": "EK",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-10T21:24:00.000Z",
                "stops": [
                    "BKK"
                ],
                "duration": 1448
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T03:36:00.000Z",
                "stops": [
                    "IST",
                    "AUH",
                    "BKK"
                ],
                "duration": 1733
            }
        ]
    },
    {
        "price": 98570,
        "carrier": "S7",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T12:53:00.000Z",
                "stops": [
                    "SHA"
                ],
                "duration": 1610
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T14:35:00.000Z",
                "stops": [
                    "KUL",
                    "SHA",
                    "AUH"
                ],
                "duration": 1310
            }
        ]
    },
    {
        "price": 69611,
        "carrier": "MH",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T08:48:00.000Z",
                "stops": [],
                "duration": 1988
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T04:05:00.000Z",
                "stops": [
                    "HKG",
                    "IST",
                    "AUH"
                ],
                "duration": 1906
            }
        ]
    },
    {
        "price": 87774,
        "carrier": "EY",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T05:05:00.000Z",
                "stops": [
                    "DXB",
                    "BKK",
                    "AUH"
                ],
                "duration": 1528
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T13:50:00.000Z",
                "stops": [
                    "IST",
                    "SHA"
                ],
                "duration": 785
            }
        ]
    },
    {
        "price": 97611,
        "carrier": "S7",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T04:39:00.000Z",
                "stops": [
                    "SHA"
                ],
                "duration": 1506
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-30T22:01:00.000Z",
                "stops": [
                    "AUH",
                    "SHA"
                ],
                "duration": 905
            }
        ]
    },
    {
        "price": 17894,
        "carrier": "EY",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T13:58:00.000Z",
                "stops": [],
                "duration": 1712
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T06:36:00.000Z",
                "stops": [
                    "IST",
                    "BKK",
                    "KUL"
                ],
                "duration": 663
            }
        ]
    },
    {
        "price": 50190,
        "carrier": "TG",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T00:58:00.000Z",
                "stops": [
                    "HKG",
                    "IST",
                    "SHA"
                ],
                "duration": 1916
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T09:43:00.000Z",
                "stops": [
                    "KUL",
                    "HKG",
                    "BKK"
                ],
                "duration": 1210
            }
        ]
    },
    {
        "price": 58953,
        "carrier": "FV",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T17:31:00.000Z",
                "stops": [
                    "AUH",
                    "SHA"
                ],
                "duration": 812
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T10:34:00.000Z",
                "stops": [
                    "HKG",
                    "BKK",
                    "IST"
                ],
                "duration": 670
            }
        ]
    },
    {
        "price": 75178,
        "carrier": "FV",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-10T23:59:00.000Z",
                "stops": [
                    "DXB"
                ],
                "duration": 703
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T14:39:00.000Z",
                "stops": [],
                "duration": 1193
            }
        ]
    },
    {
        "price": 56291,
        "carrier": "S7",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T10:43:00.000Z",
                "stops": [
                    "HKG",
                    "SHA"
                ],
                "duration": 1671
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T15:58:00.000Z",
                "stops": [
                    "HKG",
                    "DXB"
                ],
                "duration": 754
            }
        ]
    },
    {
        "price": 94547,
        "carrier": "EY",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T12:58:00.000Z",
                "stops": [
                    "BKK"
                ],
                "duration": 1901
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-30T22:59:00.000Z",
                "stops": [
                    "AUH"
                ],
                "duration": 634
            }
        ]
    },
    {
        "price": 78722,
        "carrier": "TG",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T11:34:00.000Z",
                "stops": [
                    "KUL",
                    "DXB"
                ],
                "duration": 1459
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T08:23:00.000Z",
                "stops": [
                    "KUL"
                ],
                "duration": 870
            }
        ]
    },
    {
        "price": 16168,
        "carrier": "MH",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T16:41:00.000Z",
                "stops": [
                    "IST",
                    "DXB"
                ],
                "duration": 1627
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T16:02:00.000Z",
                "stops": [
                    "SHA"
                ],
                "duration": 631
            }
        ]
    },
    {
        "price": 49557,
        "carrier": "EK",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T16:58:00.000Z",
                "stops": [
                    "SHA"
                ],
                "duration": 1105
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T17:27:00.000Z",
                "stops": [
                    "SHA",
                    "DXB"
                ],
                "duration": 1716
            }
        ]
    },
    {
        "price": 57592,
        "carrier": "S7",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T17:17:00.000Z",
                "stops": [
                    "HKG",
                    "BKK"
                ],
                "duration": 1321
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T12:13:00.000Z",
                "stops": [],
                "duration": 1905
            }
        ]
    },
    {
        "price": 75957,
        "carrier": "SU",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-10T22:58:00.000Z",
                "stops": [],
                "duration": 1643
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T14:14:00.000Z",
                "stops": [
                    "AUH",
                    "SIN"
                ],
                "duration": 949
            }
        ]
    },
    {
        "price": 26299,
        "carrier": "FV",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T03:28:00.000Z",
                "stops": [],
                "duration": 1269
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T01:14:00.000Z",
                "stops": [],
                "duration": 921
            }
        ]
    },
    {
        "price": 87055,
        "carrier": "EK",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T08:19:00.000Z",
                "stops": [
                    "KUL",
                    "SHA"
                ],
                "duration": 1469
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T14:41:00.000Z",
                "stops": [
                    "SHA"
                ],
                "duration": 1198
            }
        ]
    },
    {
        "price": 73842,
        "carrier": "SU",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T05:58:00.000Z",
                "stops": [
                    "BKK",
                    "DXB",
                    "SHA"
                ],
                "duration": 1543
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T04:40:00.000Z",
                "stops": [
                    "HKG"
                ],
                "duration": 1531
            }
        ]
    },
    {
        "price": 32413,
        "carrier": "FV",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T10:29:00.000Z",
                "stops": [
                    "IST",
                    "DXB",
                    "AUH"
                ],
                "duration": 1296
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T09:11:00.000Z",
                "stops": [
                    "SHA",
                    "KUL"
                ],
                "duration": 1949
            }
        ]
    },
    {
        "price": 30446,
        "carrier": "FV",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T13:28:00.000Z",
                "stops": [
                    "BKK"
                ],
                "duration": 750
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T10:30:00.000Z",
                "stops": [
                    "AUH",
                    "IST"
                ],
                "duration": 1851
            }
        ]
    },
    {
        "price": 71158,
        "carrier": "SU",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T12:47:00.000Z",
                "stops": [
                    "IST",
                    "HKG",
                    "DXB"
                ],
                "duration": 1426
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T02:48:00.000Z",
                "stops": [],
                "duration": 1047
            }
        ]
    },
    {
        "price": 62448,
        "carrier": "MH",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T01:58:00.000Z",
                "stops": [
                    "IST",
                    "SHA",
                    "SIN"
                ],
                "duration": 1547
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T06:14:00.000Z",
                "stops": [
                    "HKG",
                    "KUL"
                ],
                "duration": 1401
            }
        ]
    },
    {
        "price": 33139,
        "carrier": "S7",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T03:04:00.000Z",
                "stops": [],
                "duration": 1570
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T14:26:00.000Z",
                "stops": [
                    "HKG",
                    "SIN"
                ],
                "duration": 1116
            }
        ]
    },
    {
        "price": 34740,
        "carrier": "TG",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T01:42:00.000Z",
                "stops": [
                    "DXB"
                ],
                "duration": 759
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T12:37:00.000Z",
                "stops": [
                    "DXB",
                    "KUL",
                    "BKK"
                ],
                "duration": 1487
            }
        ]
    },
    {
        "price": 25557,
        "carrier": "EY",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T14:00:00.000Z",
                "stops": [],
                "duration": 947
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T09:17:00.000Z",
                "stops": [
                    "SIN"
                ],
                "duration": 1183
            }
        ]
    },
    {
        "price": 29730,
        "carrier": "SU",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T09:29:00.000Z",
                "stops": [
                    "KUL"
                ],
                "duration": 1364
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T15:06:00.000Z",
                "stops": [
                    "IST",
                    "DXB",
                    "AUH"
                ],
                "duration": 642
            }
        ]
    },
    {
        "price": 79473,
        "carrier": "EK",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T08:58:00.000Z",
                "stops": [],
                "duration": 1203
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T06:06:00.000Z",
                "stops": [
                    "SHA"
                ],
                "duration": 1249
            }
        ]
    },
    {
        "price": 54238,
        "carrier": "EK",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T05:40:00.000Z",
                "stops": [],
                "duration": 958
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T06:27:00.000Z",
                "stops": [
                    "SIN"
                ],
                "duration": 1526
            }
        ]
    },
    {
        "price": 30288,
        "carrier": "EY",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T04:40:00.000Z",
                "stops": [
                    "AUH",
                    "SIN",
                    "BKK"
                ],
                "duration": 1288
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T07:55:00.000Z",
                "stops": [],
                "duration": 610
            }
        ]
    },
    {
        "price": 80111,
        "carrier": "EY",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T08:47:00.000Z",
                "stops": [
                    "SHA"
                ],
                "duration": 1477
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T00:01:00.000Z",
                "stops": [
                    "SIN",
                    "HKG"
                ],
                "duration": 1589
            }
        ]
    },
    {
        "price": 37613,
        "carrier": "EK",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-10T22:32:00.000Z",
                "stops": [
                    "SIN"
                ],
                "duration": 959
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T02:55:00.000Z",
                "stops": [],
                "duration": 1922
            }
        ]
    },
    {
        "price": 69258,
        "carrier": "TG",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-10T21:14:00.000Z",
                "stops": [
                    "KUL",
                    "BKK"
                ],
                "duration": 1369
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T14:12:00.000Z",
                "stops": [
                    "AUH",
                    "IST",
                    "KUL"
                ],
                "duration": 1606
            }
        ]
    },
    {
        "price": 59130,
        "carrier": "EY",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T04:47:00.000Z",
                "stops": [
                    "SHA",
                    "SIN"
                ],
                "duration": 1693
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T09:19:00.000Z",
                "stops": [
                    "SHA",
                    "KUL"
                ],
                "duration": 1135
            }
        ]
    },
    {
        "price": 72180,
        "carrier": "SU",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-10T21:50:00.000Z",
                "stops": [],
                "duration": 1205
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T02:14:00.000Z",
                "stops": [
                    "HKG"
                ],
                "duration": 1988
            }
        ]
    },
    {
        "price": 92598,
        "carrier": "S7",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T15:50:00.000Z",
                "stops": [
                    "SHA",
                    "DXB"
                ],
                "duration": 948
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T04:58:00.000Z",
                "stops": [],
                "duration": 1683
            }
        ]
    },
    {
        "price": 56812,
        "carrier": "TG",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T15:10:00.000Z",
                "stops": [
                    "SIN",
                    "BKK"
                ],
                "duration": 1528
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T02:07:00.000Z",
                "stops": [
                    "KUL",
                    "SIN"
                ],
                "duration": 732
            }
        ]
    },
    {
        "price": 87012,
        "carrier": "EK",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T15:49:00.000Z",
                "stops": [
                    "IST",
                    "SIN",
                    "DXB"
                ],
                "duration": 1091
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T01:21:00.000Z",
                "stops": [
                    "KUL",
                    "DXB",
                    "SIN"
                ],
                "duration": 853
            }
        ]
    },
    {
        "price": 86434,
        "carrier": "EY",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-10T21:28:00.000Z",
                "stops": [
                    "AUH"
                ],
                "duration": 1832
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T16:40:00.000Z",
                "stops": [
                    "AUH",
                    "KUL",
                    "DXB"
                ],
                "duration": 657
            }
        ]
    },
    {
        "price": 83228,
        "carrier": "EK",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T03:12:00.000Z",
                "stops": [
                    "SIN",
                    "BKK"
                ],
                "duration": 1990
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-30T22:51:00.000Z",
                "stops": [
                    "SIN",
                    "SHA",
                    "HKG"
                ],
                "duration": 1469
            }
        ]
    },
    {
        "price": 83711,
        "carrier": "EK",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T11:25:00.000Z",
                "stops": [
                    "SHA",
                    "AUH",
                    "BKK"
                ],
                "duration": 1886
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T00:03:00.000Z",
                "stops": [
                    "DXB",
                    "AUH",
                    "BKK"
                ],
                "duration": 1024
            }
        ]
    },
    {
        "price": 20835,
        "carrier": "TG",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T04:58:00.000Z",
                "stops": [
                    "BKK",
                    "SHA"
                ],
                "duration": 1640
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T05:52:00.000Z",
                "stops": [
                    "SIN"
                ],
                "duration": 1961
            }
        ]
    },
    {
        "price": 17719,
        "carrier": "FV",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T10:47:00.000Z",
                "stops": [
                    "BKK",
                    "SIN"
                ],
                "duration": 1835
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T03:54:00.000Z",
                "stops": [
                    "SIN",
                    "DXB",
                    "KUL"
                ],
                "duration": 831
            }
        ]
    },
    {
        "price": 73593,
        "carrier": "MH",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T02:08:00.000Z",
                "stops": [
                    "IST",
                    "AUH",
                    "BKK"
                ],
                "duration": 728
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T01:05:00.000Z",
                "stops": [],
                "duration": 1374
            }
        ]
    },
    {
        "price": 67417,
        "carrier": "EY",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-10T23:48:00.000Z",
                "stops": [],
                "duration": 923
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T17:31:00.000Z",
                "stops": [
                    "HKG"
                ],
                "duration": 960
            }
        ]
    },
    {
        "price": 71951,
        "carrier": "S7",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T12:55:00.000Z",
                "stops": [
                    "BKK",
                    "KUL"
                ],
                "duration": 1048
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-30T22:34:00.000Z",
                "stops": [
                    "KUL"
                ],
                "duration": 1500
            }
        ]
    },
    {
        "price": 68482,
        "carrier": "S7",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T17:41:00.000Z",
                "stops": [],
                "duration": 1328
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-30T22:52:00.000Z",
                "stops": [],
                "duration": 665
            }
        ]
    },
    {
        "price": 79754,
        "carrier": "SU",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T10:09:00.000Z",
                "stops": [
                    "BKK"
                ],
                "duration": 812
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T12:49:00.000Z",
                "stops": [
                    "DXB"
                ],
                "duration": 1335
            }
        ]
    },
    {
        "price": 96471,
        "carrier": "TG",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T03:44:00.000Z",
                "stops": [
                    "DXB",
                    "IST",
                    "KUL"
                ],
                "duration": 1417
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T11:41:00.000Z",
                "stops": [
                    "KUL",
                    "DXB"
                ],
                "duration": 1639
            }
        ]
    },
    {
        "price": 73411,
        "carrier": "TG",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T12:16:00.000Z",
                "stops": [],
                "duration": 1508
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T06:58:00.000Z",
                "stops": [
                    "KUL",
                    "IST"
                ],
                "duration": 1608
            }
        ]
    },
    {
        "price": 91931,
        "carrier": "SU",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T04:27:00.000Z",
                "stops": [
                    "BKK",
                    "SHA"
                ],
                "duration": 1074
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T14:04:00.000Z",
                "stops": [
                    "AUH"
                ],
                "duration": 847
            }
        ]
    },
    {
        "price": 85138,
        "carrier": "S7",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T01:58:00.000Z",
                "stops": [
                    "AUH"
                ],
                "duration": 1925
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T17:59:00.000Z",
                "stops": [
                    "SHA",
                    "KUL",
                    "SIN"
                ],
                "duration": 1135
            }
        ]
    },
    {
        "price": 55034,
        "carrier": "SU",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T06:09:00.000Z",
                "stops": [
                    "DXB",
                    "BKK",
                    "IST"
                ],
                "duration": 1575
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T15:26:00.000Z",
                "stops": [
                    "AUH",
                    "BKK",
                    "DXB"
                ],
                "duration": 664
            }
        ]
    },
    {
        "price": 56270,
        "carrier": "SU",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T10:49:00.000Z",
                "stops": [
                    "AUH",
                    "SHA"
                ],
                "duration": 1427
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T06:18:00.000Z",
                "stops": [
                    "HKG",
                    "BKK"
                ],
                "duration": 938
            }
        ]
    },
    {
        "price": 42165,
        "carrier": "SU",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T13:08:00.000Z",
                "stops": [
                    "HKG",
                    "BKK"
                ],
                "duration": 1355
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T07:42:00.000Z",
                "stops": [
                    "AUH",
                    "BKK",
                    "SIN"
                ],
                "duration": 1016
            }
        ]
    },
    {
        "price": 57428,
        "carrier": "S7",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T00:58:00.000Z",
                "stops": [
                    "DXB",
                    "IST"
                ],
                "duration": 1873
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T01:47:00.000Z",
                "stops": [
                    "SHA"
                ],
                "duration": 1627
            }
        ]
    },
    {
        "price": 64975,
        "carrier": "EK",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T05:58:00.000Z",
                "stops": [
                    "AUH"
                ],
                "duration": 933
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T02:22:00.000Z",
                "stops": [
                    "DXB",
                    "HKG",
                    "SHA"
                ],
                "duration": 1303
            }
        ]
    },
    {
        "price": 84758,
        "carrier": "EY",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-10T21:42:00.000Z",
                "stops": [
                    "DXB",
                    "KUL",
                    "BKK"
                ],
                "duration": 1117
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T09:10:00.000Z",
                "stops": [],
                "duration": 1364
            }
        ]
    },
    {
        "price": 59637,
        "carrier": "EY",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T16:36:00.000Z",
                "stops": [
                    "HKG",
                    "AUH",
                    "SIN"
                ],
                "duration": 965
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T15:41:00.000Z",
                "stops": [
                    "HKG"
                ],
                "duration": 1232
            }
        ]
    },
    {
        "price": 86507,
        "carrier": "EK",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T09:02:00.000Z",
                "stops": [
                    "SIN"
                ],
                "duration": 1474
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T14:40:00.000Z",
                "stops": [
                    "SHA",
                    "DXB"
                ],
                "duration": 1833
            }
        ]
    },
    {
        "price": 78535,
        "carrier": "SU",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T02:34:00.000Z",
                "stops": [],
                "duration": 1631
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T16:52:00.000Z",
                "stops": [
                    "DXB",
                    "IST",
                    "SHA"
                ],
                "duration": 1988
            }
        ]
    },
    {
        "price": 59189,
        "carrier": "TG",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T08:21:00.000Z",
                "stops": [
                    "BKK",
                    "HKG",
                    "SIN"
                ],
                "duration": 1299
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T17:27:00.000Z",
                "stops": [],
                "duration": 919
            }
        ]
    },
    {
        "price": 75811,
        "carrier": "MH",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T08:47:00.000Z",
                "stops": [
                    "KUL",
                    "SIN",
                    "SHA"
                ],
                "duration": 1654
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T06:01:00.000Z",
                "stops": [
                    "IST"
                ],
                "duration": 1800
            }
        ]
    },
    {
        "price": 81988,
        "carrier": "SU",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T14:51:00.000Z",
                "stops": [
                    "SIN"
                ],
                "duration": 1928
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T02:02:00.000Z",
                "stops": [
                    "KUL",
                    "SIN",
                    "IST"
                ],
                "duration": 628
            }
        ]
    },
    {
        "price": 69356,
        "carrier": "SU",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-10T21:13:00.000Z",
                "stops": [],
                "duration": 665
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T14:18:00.000Z",
                "stops": [
                    "HKG"
                ],
                "duration": 1864
            }
        ]
    },
    {
        "price": 39909,
        "carrier": "EK",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-10T21:07:00.000Z",
                "stops": [
                    "AUH",
                    "SIN",
                    "DXB"
                ],
                "duration": 669
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T02:04:00.000Z",
                "stops": [],
                "duration": 1392
            }
        ]
    },
    {
        "price": 80439,
        "carrier": "MH",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T14:32:00.000Z",
                "stops": [
                    "BKK",
                    "SHA",
                    "HKG"
                ],
                "duration": 1129
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T01:59:00.000Z",
                "stops": [
                    "AUH"
                ],
                "duration": 1137
            }
        ]
    },
    {
        "price": 89211,
        "carrier": "MH",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T15:24:00.000Z",
                "stops": [],
                "duration": 1926
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T15:07:00.000Z",
                "stops": [
                    "AUH",
                    "DXB"
                ],
                "duration": 1749
            }
        ]
    },
    {
        "price": 61344,
        "carrier": "EY",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T12:20:00.000Z",
                "stops": [
                    "DXB",
                    "KUL"
                ],
                "duration": 1115
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T13:48:00.000Z",
                "stops": [],
                "duration": 610
            }
        ]
    },
    {
        "price": 91677,
        "carrier": "SU",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T09:07:00.000Z",
                "stops": [],
                "duration": 1328
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T16:37:00.000Z",
                "stops": [
                    "HKG"
                ],
                "duration": 857
            }
        ]
    },
    {
        "price": 23961,
        "carrier": "SU",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T02:04:00.000Z",
                "stops": [
                    "BKK",
                    "DXB"
                ],
                "duration": 746
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T04:45:00.000Z",
                "stops": [
                    "SIN",
                    "IST",
                    "KUL"
                ],
                "duration": 1743
            }
        ]
    },
    {
        "price": 15248,
        "carrier": "EK",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T15:48:00.000Z",
                "stops": [],
                "duration": 1537
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T07:56:00.000Z",
                "stops": [
                    "KUL"
                ],
                "duration": 888
            }
        ]
    },
    {
        "price": 46508,
        "carrier": "SU",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T17:20:00.000Z",
                "stops": [
                    "SHA"
                ],
                "duration": 1386
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T00:29:00.000Z",
                "stops": [
                    "KUL",
                    "SIN"
                ],
                "duration": 852
            }
        ]
    },
    {
        "price": 36962,
        "carrier": "TG",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T17:14:00.000Z",
                "stops": [
                    "SHA",
                    "IST"
                ],
                "duration": 745
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T11:43:00.000Z",
                "stops": [
                    "DXB",
                    "BKK"
                ],
                "duration": 1525
            }
        ]
    },
    {
        "price": 91589,
        "carrier": "TG",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T08:57:00.000Z",
                "stops": [
                    "SIN",
                    "IST"
                ],
                "duration": 1737
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T16:13:00.000Z",
                "stops": [
                    "SHA"
                ],
                "duration": 1793
            }
        ]
    },
    {
        "price": 43684,
        "carrier": "TG",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T01:34:00.000Z",
                "stops": [],
                "duration": 623
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T12:54:00.000Z",
                "stops": [
                    "IST",
                    "AUH"
                ],
                "duration": 809
            }
        ]
    },
    {
        "price": 57766,
        "carrier": "EY",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T11:01:00.000Z",
                "stops": [
                    "AUH"
                ],
                "duration": 1231
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T04:15:00.000Z",
                "stops": [
                    "IST"
                ],
                "duration": 1865
            }
        ]
    },
    {
        "price": 67765,
        "carrier": "EK",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T17:15:00.000Z",
                "stops": [],
                "duration": 1828
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T02:44:00.000Z",
                "stops": [],
                "duration": 683
            }
        ]
    },
    {
        "price": 20680,
        "carrier": "TG",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T11:01:00.000Z",
                "stops": [
                    "AUH",
                    "KUL",
                    "DXB"
                ],
                "duration": 1272
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T01:39:00.000Z",
                "stops": [
                    "KUL",
                    "BKK"
                ],
                "duration": 1727
            }
        ]
    },
    {
        "price": 94579,
        "carrier": "FV",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T17:54:00.000Z",
                "stops": [
                    "HKG",
                    "AUH"
                ],
                "duration": 1162
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T12:30:00.000Z",
                "stops": [
                    "SHA",
                    "IST",
                    "HKG"
                ],
                "duration": 693
            }
        ]
    },
    {
        "price": 56356,
        "carrier": "SU",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-10T23:13:00.000Z",
                "stops": [
                    "BKK",
                    "SHA",
                    "AUH"
                ],
                "duration": 1702
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T06:47:00.000Z",
                "stops": [],
                "duration": 628
            }
        ]
    },
    {
        "price": 23208,
        "carrier": "EK",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T15:26:00.000Z",
                "stops": [
                    "BKK"
                ],
                "duration": 1834
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T00:49:00.000Z",
                "stops": [
                    "BKK",
                    "KUL",
                    "IST"
                ],
                "duration": 1946
            }
        ]
    },
    {
        "price": 61378,
        "carrier": "FV",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T09:29:00.000Z",
                "stops": [
                    "DXB"
                ],
                "duration": 1683
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T11:05:00.000Z",
                "stops": [
                    "DXB",
                    "AUH",
                    "SHA"
                ],
                "duration": 742
            }
        ]
    },
    {
        "price": 72779,
        "carrier": "S7",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T13:02:00.000Z",
                "stops": [
                    "BKK",
                    "IST",
                    "SIN"
                ],
                "duration": 875
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T12:48:00.000Z",
                "stops": [
                    "IST"
                ],
                "duration": 1548
            }
        ]
    },
    {
        "price": 89189,
        "carrier": "FV",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T03:05:00.000Z",
                "stops": [
                    "SIN",
                    "SHA"
                ],
                "duration": 762
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T04:32:00.000Z",
                "stops": [],
                "duration": 1595
            }
        ]
    },
    {
        "price": 43669,
        "carrier": "TG",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T07:44:00.000Z",
                "stops": [
                    "HKG"
                ],
                "duration": 1578
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T02:58:00.000Z",
                "stops": [
                    "DXB"
                ],
                "duration": 1305
            }
        ]
    },
    {
        "price": 95309,
        "carrier": "MH",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T00:04:00.000Z",
                "stops": [
                    "DXB",
                    "KUL"
                ],
                "duration": 671
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T13:54:00.000Z",
                "stops": [
                    "IST"
                ],
                "duration": 1177
            }
        ]
    },
    {
        "price": 77678,
        "carrier": "FV",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-10T22:35:00.000Z",
                "stops": [
                    "IST",
                    "AUH",
                    "SIN"
                ],
                "duration": 1923
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T03:29:00.000Z",
                "stops": [],
                "duration": 1961
            }
        ]
    },
    {
        "price": 42723,
        "carrier": "SU",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T01:43:00.000Z",
                "stops": [
                    "KUL",
                    "AUH",
                    "DXB"
                ],
                "duration": 1794
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T10:44:00.000Z",
                "stops": [
                    "IST"
                ],
                "duration": 974
            }
        ]
    },
    {
        "price": 51852,
        "carrier": "EK",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T09:05:00.000Z",
                "stops": [],
                "duration": 1139
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T13:00:00.000Z",
                "stops": [
                    "SIN"
                ],
                "duration": 1668
            }
        ]
    },
    {
        "price": 34184,
        "carrier": "MH",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T00:56:00.000Z",
                "stops": [],
                "duration": 914
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-30T21:07:00.000Z",
                "stops": [
                    "AUH",
                    "DXB",
                    "HKG"
                ],
                "duration": 1477
            }
        ]
    },
    {
        "price": 58873,
        "carrier": "EK",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T17:59:00.000Z",
                "stops": [
                    "DXB",
                    "KUL"
                ],
                "duration": 903
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T01:35:00.000Z",
                "stops": [
                    "SHA"
                ],
                "duration": 1120
            }
        ]
    },
    {
        "price": 40820,
        "carrier": "EK",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T04:52:00.000Z",
                "stops": [
                    "HKG",
                    "BKK",
                    "AUH"
                ],
                "duration": 977
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T02:09:00.000Z",
                "stops": [],
                "duration": 1937
            }
        ]
    },
    {
        "price": 93062,
        "carrier": "S7",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T13:53:00.000Z",
                "stops": [
                    "IST",
                    "DXB"
                ],
                "duration": 1230
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T12:24:00.000Z",
                "stops": [],
                "duration": 1556
            }
        ]
    },
    {
        "price": 64704,
        "carrier": "EY",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T08:00:00.000Z",
                "stops": [
                    "SHA",
                    "AUH",
                    "DXB"
                ],
                "duration": 1655
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T10:32:00.000Z",
                "stops": [
                    "AUH",
                    "DXB",
                    "BKK"
                ],
                "duration": 1131
            }
        ]
    },
    {
        "price": 72545,
        "carrier": "TG",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T04:59:00.000Z",
                "stops": [
                    "KUL",
                    "BKK",
                    "DXB"
                ],
                "duration": 1278
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T15:12:00.000Z",
                "stops": [
                    "SHA",
                    "DXB"
                ],
                "duration": 1391
            }
        ]
    },
    {
        "price": 17491,
        "carrier": "TG",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T09:02:00.000Z",
                "stops": [
                    "AUH",
                    "BKK",
                    "SIN"
                ],
                "duration": 1987
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T08:39:00.000Z",
                "stops": [
                    "SHA",
                    "KUL"
                ],
                "duration": 981
            }
        ]
    },
    {
        "price": 75983,
        "carrier": "EK",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T08:05:00.000Z",
                "stops": [
                    "SHA"
                ],
                "duration": 1830
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-30T22:06:00.000Z",
                "stops": [
                    "KUL",
                    "HKG",
                    "DXB"
                ],
                "duration": 924
            }
        ]
    },
    {
        "price": 68124,
        "carrier": "FV",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T14:49:00.000Z",
                "stops": [
                    "SIN",
                    "HKG"
                ],
                "duration": 1841
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T10:35:00.000Z",
                "stops": [
                    "BKK"
                ],
                "duration": 1655
            }
        ]
    },
    {
        "price": 15893,
        "carrier": "S7",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T08:39:00.000Z",
                "stops": [
                    "HKG",
                    "SHA"
                ],
                "duration": 1005
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T04:39:00.000Z",
                "stops": [
                    "SHA"
                ],
                "duration": 1504
            }
        ]
    },
    {
        "price": 87114,
        "carrier": "FV",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T04:08:00.000Z",
                "stops": [],
                "duration": 699
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T15:31:00.000Z",
                "stops": [
                    "DXB"
                ],
                "duration": 1783
            }
        ]
    },
    {
        "price": 25939,
        "carrier": "S7",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T01:34:00.000Z",
                "stops": [
                    "KUL",
                    "HKG"
                ],
                "duration": 1711
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T05:47:00.000Z",
                "stops": [
                    "SHA",
                    "SIN",
                    "HKG"
                ],
                "duration": 1784
            }
        ]
    },
    {
        "price": 66018,
        "carrier": "EY",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T02:48:00.000Z",
                "stops": [
                    "HKG",
                    "SIN",
                    "AUH"
                ],
                "duration": 1973
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T11:05:00.000Z",
                "stops": [
                    "DXB",
                    "SIN"
                ],
                "duration": 1391
            }
        ]
    },
    {
        "price": 30763,
        "carrier": "FV",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-10T21:41:00.000Z",
                "stops": [
                    "SHA"
                ],
                "duration": 1370
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T11:19:00.000Z",
                "stops": [
                    "AUH",
                    "IST",
                    "SHA"
                ],
                "duration": 1287
            }
        ]
    },
    {
        "price": 90810,
        "carrier": "SU",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T10:38:00.000Z",
                "stops": [],
                "duration": 794
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T00:55:00.000Z",
                "stops": [
                    "DXB",
                    "IST",
                    "SIN"
                ],
                "duration": 1569
            }
        ]
    },
    {
        "price": 54974,
        "carrier": "S7",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T03:49:00.000Z",
                "stops": [
                    "AUH",
                    "BKK"
                ],
                "duration": 1905
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T17:55:00.000Z",
                "stops": [
                    "DXB"
                ],
                "duration": 1772
            }
        ]
    },
    {
        "price": 53515,
        "carrier": "MH",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T05:15:00.000Z",
                "stops": [
                    "BKK",
                    "HKG"
                ],
                "duration": 1810
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T14:58:00.000Z",
                "stops": [
                    "IST",
                    "AUH",
                    "HKG"
                ],
                "duration": 1439
            }
        ]
    },
    {
        "price": 75478,
        "carrier": "FV",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T14:57:00.000Z",
                "stops": [],
                "duration": 915
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T03:37:00.000Z",
                "stops": [
                    "KUL",
                    "SIN"
                ],
                "duration": 1690
            }
        ]
    },
    {
        "price": 52258,
        "carrier": "EY",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T06:50:00.000Z",
                "stops": [
                    "KUL",
                    "AUH",
                    "BKK"
                ],
                "duration": 1181
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T00:53:00.000Z",
                "stops": [
                    "SIN"
                ],
                "duration": 714
            }
        ]
    },
    {
        "price": 71904,
        "carrier": "S7",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T09:58:00.000Z",
                "stops": [
                    "AUH",
                    "SIN"
                ],
                "duration": 1155
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T13:08:00.000Z",
                "stops": [
                    "HKG",
                    "DXB"
                ],
                "duration": 993
            }
        ]
    },
    {
        "price": 65331,
        "carrier": "EK",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T09:28:00.000Z",
                "stops": [],
                "duration": 890
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T05:26:00.000Z",
                "stops": [
                    "HKG"
                ],
                "duration": 1569
            }
        ]
    },
    {
        "price": 63102,
        "carrier": "S7",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T17:47:00.000Z",
                "stops": [
                    "KUL"
                ],
                "duration": 1287
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T09:58:00.000Z",
                "stops": [
                    "KUL",
                    "DXB"
                ],
                "duration": 1185
            }
        ]
    },
    {
        "price": 70454,
        "carrier": "TG",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-10T21:48:00.000Z",
                "stops": [],
                "duration": 877
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T04:32:00.000Z",
                "stops": [
                    "DXB",
                    "BKK",
                    "SIN"
                ],
                "duration": 606
            }
        ]
    },
    {
        "price": 70094,
        "carrier": "SU",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T11:28:00.000Z",
                "stops": [
                    "SHA"
                ],
                "duration": 1579
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T10:41:00.000Z",
                "stops": [],
                "duration": 1327
            }
        ]
    },
    {
        "price": 59275,
        "carrier": "FV",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T08:54:00.000Z",
                "stops": [
                    "IST",
                    "SHA",
                    "KUL"
                ],
                "duration": 1502
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T04:08:00.000Z",
                "stops": [],
                "duration": 913
            }
        ]
    },
    {
        "price": 60392,
        "carrier": "FV",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T01:01:00.000Z",
                "stops": [
                    "DXB"
                ],
                "duration": 1305
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T10:10:00.000Z",
                "stops": [
                    "SHA"
                ],
                "duration": 1887
            }
        ]
    },
    {
        "price": 39252,
        "carrier": "TG",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T07:44:00.000Z",
                "stops": [],
                "duration": 1060
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T15:27:00.000Z",
                "stops": [
                    "BKK",
                    "AUH",
                    "HKG"
                ],
                "duration": 1123
            }
        ]
    },
    {
        "price": 66904,
        "carrier": "S7",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T04:53:00.000Z",
                "stops": [
                    "HKG",
                    "BKK"
                ],
                "duration": 632
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-30T23:28:00.000Z",
                "stops": [
                    "SHA",
                    "BKK",
                    "IST"
                ],
                "duration": 1130
            }
        ]
    },
    {
        "price": 97442,
        "carrier": "EK",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T16:20:00.000Z",
                "stops": [
                    "SIN"
                ],
                "duration": 1001
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T11:47:00.000Z",
                "stops": [
                    "DXB",
                    "AUH",
                    "KUL"
                ],
                "duration": 994
            }
        ]
    },
    {
        "price": 32839,
        "carrier": "FV",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T13:07:00.000Z",
                "stops": [
                    "SIN",
                    "DXB",
                    "AUH"
                ],
                "duration": 1043
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-30T21:56:00.000Z",
                "stops": [
                    "BKK"
                ],
                "duration": 1913
            }
        ]
    },
    {
        "price": 26793,
        "carrier": "S7",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T13:38:00.000Z",
                "stops": [
                    "BKK",
                    "AUH",
                    "DXB"
                ],
                "duration": 1387
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T12:33:00.000Z",
                "stops": [
                    "BKK",
                    "SHA",
                    "IST"
                ],
                "duration": 1168
            }
        ]
    },
    {
        "price": 45213,
        "carrier": "EY",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-10T21:15:00.000Z",
                "stops": [
                    "IST"
                ],
                "duration": 1868
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T16:52:00.000Z",
                "stops": [
                    "BKK",
                    "AUH",
                    "HKG"
                ],
                "duration": 969
            }
        ]
    },
    {
        "price": 35199,
        "carrier": "MH",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T08:02:00.000Z",
                "stops": [
                    "BKK",
                    "SIN"
                ],
                "duration": 1724
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T00:46:00.000Z",
                "stops": [],
                "duration": 600
            }
        ]
    },
    {
        "price": 75085,
        "carrier": "MH",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T07:23:00.000Z",
                "stops": [
                    "IST",
                    "HKG"
                ],
                "duration": 855
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T04:03:00.000Z",
                "stops": [],
                "duration": 1084
            }
        ]
    },
    {
        "price": 15433,
        "carrier": "MH",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T04:34:00.000Z",
                "stops": [
                    "BKK"
                ],
                "duration": 907
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T01:31:00.000Z",
                "stops": [
                    "KUL"
                ],
                "duration": 1859
            }
        ]
    },
    {
        "price": 26272,
        "carrier": "S7",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T16:16:00.000Z",
                "stops": [
                    "DXB"
                ],
                "duration": 840
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T08:30:00.000Z",
                "stops": [
                    "DXB"
                ],
                "duration": 1689
            }
        ]
    },
    {
        "price": 28632,
        "carrier": "EY",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T11:19:00.000Z",
                "stops": [
                    "DXB"
                ],
                "duration": 1267
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T08:17:00.000Z",
                "stops": [
                    "SIN",
                    "IST"
                ],
                "duration": 1780
            }
        ]
    },
    {
        "price": 24163,
        "carrier": "SU",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T05:37:00.000Z",
                "stops": [
                    "AUH",
                    "BKK"
                ],
                "duration": 1681
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T06:18:00.000Z",
                "stops": [],
                "duration": 1858
            }
        ]
    },
    {
        "price": 78809,
        "carrier": "EY",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-10T21:47:00.000Z",
                "stops": [
                    "SIN",
                    "AUH"
                ],
                "duration": 1628
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-30T23:11:00.000Z",
                "stops": [
                    "BKK",
                    "IST"
                ],
                "duration": 1778
            }
        ]
    },
    {
        "price": 37700,
        "carrier": "EY",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T14:43:00.000Z",
                "stops": [],
                "duration": 1474
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T03:14:00.000Z",
                "stops": [],
                "duration": 799
            }
        ]
    },
    {
        "price": 93402,
        "carrier": "TG",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T14:13:00.000Z",
                "stops": [],
                "duration": 1133
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T00:18:00.000Z",
                "stops": [],
                "duration": 933
            }
        ]
    },
    {
        "price": 38747,
        "carrier": "FV",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T07:24:00.000Z",
                "stops": [
                    "AUH"
                ],
                "duration": 908
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T04:20:00.000Z",
                "stops": [
                    "DXB"
                ],
                "duration": 1692
            }
        ]
    },
    {
        "price": 53314,
        "carrier": "MH",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-10T23:53:00.000Z",
                "stops": [
                    "SHA",
                    "KUL"
                ],
                "duration": 1401
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T12:41:00.000Z",
                "stops": [],
                "duration": 1213
            }
        ]
    },
    {
        "price": 50906,
        "carrier": "TG",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T12:32:00.000Z",
                "stops": [
                    "BKK",
                    "IST",
                    "HKG"
                ],
                "duration": 1397
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T09:27:00.000Z",
                "stops": [],
                "duration": 666
            }
        ]
    },
    {
        "price": 82835,
        "carrier": "EK",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-10T22:27:00.000Z",
                "stops": [
                    "AUH"
                ],
                "duration": 1766
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-30T21:15:00.000Z",
                "stops": [],
                "duration": 890
            }
        ]
    },
    {
        "price": 49597,
        "carrier": "FV",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T06:02:00.000Z",
                "stops": [
                    "AUH"
                ],
                "duration": 910
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T10:42:00.000Z",
                "stops": [],
                "duration": 1454
            }
        ]
    },
    {
        "price": 54578,
        "carrier": "S7",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-10T22:46:00.000Z",
                "stops": [],
                "duration": 1483
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T07:37:00.000Z",
                "stops": [],
                "duration": 1403
            }
        ]
    },
    {
        "price": 27291,
        "carrier": "S7",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T16:02:00.000Z",
                "stops": [
                    "AUH",
                    "KUL",
                    "IST"
                ],
                "duration": 818
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T13:35:00.000Z",
                "stops": [
                    "BKK"
                ],
                "duration": 1362
            }
        ]
    },
    {
        "price": 66719,
        "carrier": "TG",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T02:47:00.000Z",
                "stops": [],
                "duration": 1332
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-30T21:29:00.000Z",
                "stops": [
                    "HKG"
                ],
                "duration": 1347
            }
        ]
    },
    {
        "price": 15333,
        "carrier": "SU",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T00:26:00.000Z",
                "stops": [],
                "duration": 969
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-30T21:34:00.000Z",
                "stops": [
                    "SHA",
                    "DXB"
                ],
                "duration": 1500
            }
        ]
    },
    {
        "price": 47044,
        "carrier": "S7",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T13:38:00.000Z",
                "stops": [
                    "KUL"
                ],
                "duration": 1717
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T05:59:00.000Z",
                "stops": [
                    "KUL"
                ],
                "duration": 1772
            }
        ]
    },
    {
        "price": 39186,
        "carrier": "FV",
        "segments": [
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-11T17:27:00.000Z",
                "stops": [
                    "SHA",
                    "SIN"
                ],
                "duration": 1089
            },
            {
                "origin": "MOW",
                "destination": "HKT",
                "date": "2020-01-31T09:50:00.000Z",
                "stops": [
                    "AUH"
                ],
                "duration": 1490
            }
        ]
    }
]